import React, { Component, useState, useEffect, useMemo, memo } from 'react';
import SecuredZone from '../components/SecuredZone';
import Card from '../components/Card';
import '../css/main.css';
import API from '../api/api';
import LinearProgress from '@mui/material/LinearProgress';
import DeviceDialog from '../components/dialogs/device-dialog/device-dialog';
import Dialog from '@mui/material/Dialog';
import { Map, Marker } from "pigeon-maps"
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, Label } from 'recharts';
import Switch from '@mui/material/Switch';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SendIcon from '@mui/icons-material/Send';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Timeline from '@mui/lab/Timeline';
import moment from 'moment-timezone';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import Chip from '@mui/material/Chip';
import MuiTooltip from '@mui/material/Tooltip';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HistoryIcon from '@mui/icons-material/History';
import DescriptionIcon from '@mui/icons-material/Description';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import MemoryIcon from '@mui/icons-material/Memory';
import RefreshIcon from '@mui/icons-material/Refresh';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import RouterIcon from '@mui/icons-material/Router';
import TimerIcon from '@mui/icons-material/Timer';
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import StorageIcon from '@mui/icons-material/Storage';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import MonitorIcon from '@mui/icons-material/Monitor';
import SdCardIcon from '@mui/icons-material/SdCard';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import WarningIcon from '@mui/icons-material/Warning';
import CompressIcon from '@mui/icons-material/Compress';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import ReplayIcon from '@mui/icons-material/Replay';
import LinkIcon from '@mui/icons-material/Link';
import PropTypes from 'prop-types';
import { validateDeviceData } from '../utils/deviceHelpers';
import { ONLINE_THRESHOLD_MS } from '../utils/deviceConstants';
import { handleApiError } from '../utils/errorHandler';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Icon } from '../icons/AppIcons';


const FireApi = new API();
const ACTION_STATUS_POLL_INTERVAL_MS = 3000;
const ACTION_STATUS_POLL_TIMEOUT_MS = 5 * 60 * 1000;
const ALARM_VOLTAGE = 5;
const PORT_TYPE_LABEL = {
  none: 'Kein Anschluss',
  fire: 'Feuermelder',
  door: 'Türkontakt',
};

function fmtNum(value, digits = 1) {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

function portMeta(type, voltage) {
  const kind = PORT_TYPE_LABEL[type] ? type : 'none';
  const volts = fmtNum(voltage, 2);
  const alarm = kind !== 'none' && volts !== null && volts >= ALARM_VOLTAGE;
  let state = 'Nicht belegt';
  if (kind !== 'none') {
    if (volts === null) state = 'Keine Daten';
    else if (alarm) state = 'Alarm';
    else state = 'OK';
  }
  return { kind, label: PORT_TYPE_LABEL[kind], volts, alarm, state };
}

class DeviceOpen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      intervallFirmware: '',
      intervallFirmwareCurrent: 0,
      versionSelected: 0,
      actionSet: 1,
      dialogAlert: false,
      panel: {
        id: 1,
        uuid: '',
        name: '',
        lat: 0,
        active: 0,
        long: 0,
        version: '',
      },
      configuration: {
        id: 1,
        uuid: '',
        name: '',
        lat: 0,
        active: 0,
        long: 0,
        value_created: '',
        value_o: 0,
        value_t: 0,
        value_p: 0,
        value_h: 0,
        value_a: 0,
        value_g: 0,
        value_s: 0,
        value_j: 0,
        value_e: 0,
        value_r: 0,
        organisation: 0,
      },
      stats: [],
      firmware: [],
      dialogOpen: false,
      loading: true,
      chartTemperature: [],
      chartHumidity: [],
      firmwareUpdate: {
        progress: 0,
      },
      alertText: '',
      lastFirmwareUpdateId: 0,
      firmwareUpdateValues: [],
      currentActionId: null,
      actionStartTime: null,
      highestActionCodeReached: 0,
      actionHistory: [],
      actionHistoryLoading: false,
      actionHistoryTotalCount: 0,
      actionHistoryPage: 0,
      actionHistoryRowsPerPage: 10,
      selectedActionDetails: null,
      actionDetailsLoading: false,
      actionDetailsDialogOpen: false,
      panelLogs: [],
      panelLogsLoading: false,
      unconfirmedImportantLogsCount: 0,
      panelLogsPage: 0,
      panelLogsRowsPerPage: 10,
      panelLogsTotalCount: 0,
      hideHealthChecks: true,
      confirmingLogId: null,
      // Datumsauswahl für Diagramme
      chartDateFrom: dayjs().subtract(10, 'day'),
      chartDateTo: dayjs(),
      chartViewMode: 'hourly', // 'hourly' oder 'daily' für Trend
      chartDataLoading: false // Loading-State für Diagramm-Daten
    };
  }

  handleClickOpen() {
    this.setState({ dialogOpen:  true });
  }

  handleClose() {
    this.setState({ dialogOpen:  false });
  }

  handleCloseAlert() {
    this.setState({ dialogAlert:  false });
  }

  handleActionSetChange(actionSet)
  {
    // Beim Wechsel der Aktion aktive Abfragen stoppen und UI-Status zuruecksetzen.
    this.stopActionStatusPolling();
    this.setState((prevState) => ({
      actionSet,
      firmwareUpdateValues: [],
      firmwareUpdate: {
        ...prevState.firmwareUpdate,
        progress: 0
      }
    }));
  }

  handleOpenActionDetails(actionId) {
    this.setState({ 
      actionDetailsLoading: true,
      actionDetailsDialogOpen: true,
      selectedActionDetails: null
    });

    FireApi.endpoints.actionHistoryDetails.getOne({ id: actionId })
      .then((response) => {
        if(response && response.data) {
          this.setState({ 
            selectedActionDetails: response.data,
            actionDetailsLoading: false
          });
        } else {
          this.setState({ actionDetailsLoading: false });
        }
      })
      .catch((error) => {
        console.error('Fehler beim Laden der Aktionsdetails:', error);
        this.setState({ actionDetailsLoading: false });
      });
  }

  handleCloseActionDetails() {
    this.setState({ 
      actionDetailsDialogOpen: false,
      selectedActionDetails: null
    });
  }

  /**
   * Handler für Seitenwechsel in der Aktionsverlauf-Pagination
   * 
   * @param {Object} event - Event-Objekt
   * @param {number} newPage - Neue Seitennummer (0-basiert)
   */
  handleActionHistoryChangePage = (event, newPage) => {
    this.setState({ actionHistoryPage: newPage }, () => {
      this.loadActionHistory();
    });
  };

  /**
   * Handler für Änderung der Zeilen pro Seite im Aktionsverlauf
   * 
   * @param {Object} event - Event-Objekt mit target.value
   */
  handleActionHistoryChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    this.setState({ actionHistoryRowsPerPage: newRowsPerPage, actionHistoryPage: 0 }, () => {
      this.loadActionHistory();
    });
  };

  /**
   * Handler für Seitenwechsel in der Panel-Logs-Pagination
   * 
   * @param {Object} event - Event-Objekt
   * @param {number} newPage - Neue Seitennummer (0-basiert)
   */
  handleDeviceLogsChangePage = (event, newPage) => {
    this.setState({ panelLogsPage: newPage }, () => {
      this.loadDeviceLogs();
    });
  };

  /**
   * Handler für Änderung der Zeilen pro Seite bei Panel-Logs
   * 
   * @param {Object} event - Event-Objekt mit target.value
   */
  handleDeviceLogsChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    this.setState({ panelLogsRowsPerPage: newRowsPerPage, panelLogsPage: 0 }, () => {
      this.loadDeviceLogs();
    });
  };

  submitDialog(data) {
    this.setState({ dialogOpen: false });
    const payload = data.device || data.panel || {};
    const updatedKoffer = { ...this.state.panel, ...payload };
    this.setState({ panel: updatedKoffer }, () => {
      this.updatePanelData();
    });
  }

  updatePanelData()
  {
    const p = this.state.panel || {};
    FireApi.endpoints.devices.update({
      id: p.id,
      uuid: p.uuid,
      name: p.name,
      lat: p.lat,
      long: p.long,
      active: p.active ? 1 : 0,
      port_1: p.port_1 || 'none',
      port_2: p.port_2 || 'none',
      port_3: p.port_3 || 'none',
      port_4: p.port_4 || 'none',
    }).then((res) => {
      if (res && res.data && !res.error) {
        this.setState({ panel: { ...this.state.panel, ...res.data } });
      }
      return FireApi.endpoints.devicesStatus.getOne({ id: this.props.match.params.id });
    }).then((statusGet) => {
      if (statusGet && statusGet.data) {
        let configData = statusGet.data;
        if (statusGet.data.results && statusGet.data.results[0]) {
          configData = statusGet.data.results[0];
        }
        this.setState({ configuration: configData });
      }
    }).catch(() => {});
  }

  statusChange(data)
  {
    this.setState((prev) => ({
      panel: { ...prev.panel, active: data },
      loading: false,
    }), () => {
      FireApi.endpoints.devices.update(this.state.panel);
    });
  }

  handleClickDelete()
  {
    FireApi.endpoints.devices.delete(this.state.panel);
    setTimeout(() => {
      this.props.history.push('/devices')
    }, 1000);
  }

  startActionStatusPolling(actionId)
  {
    this.stopActionStatusPolling(false);

    this.setState({
      firmwareUpdateValues: [],
      currentActionId: actionId,
      actionStartTime: Date.now(),
      highestActionCodeReached: 0,
      intervallFirmwareCurrent: 0
    }, () => {
      this.getActionStatusUpdates();

      this.actionStatusInterval = setInterval(
        this.getActionStatusUpdates.bind(this),
        ACTION_STATUS_POLL_INTERVAL_MS
      );

      this.actionStatusTimeout = setTimeout(() => {
        const errorMessage = {
          time: new Date(),
          text: 'Aktion wurde nach 5 Minuten abgebrochen (Timeout)',
          last: 1,
          communicationId: 'timeout-' + Date.now()
        };

        this.setState((prev) => ({
          firmwareUpdateValues: [...(prev.firmwareUpdateValues || []), errorMessage],
          firmwareUpdate: { ...prev.firmwareUpdate, progress: 0 },
        }));
        this.stopActionStatusPolling();
      }, ACTION_STATUS_POLL_TIMEOUT_MS);
    });
  }

  stopActionStatusPolling(resetActionState = true)
  {
    if (this.actionStatusInterval) {
      clearInterval(this.actionStatusInterval);
      this.actionStatusInterval = null;
    }

    if (this.actionStatusTimeout) {
      clearTimeout(this.actionStatusTimeout);
      this.actionStatusTimeout = null;
    }

    if (this.state.intervallFirmware) {
      clearInterval(this.state.intervallFirmware);
    }

    if (resetActionState) {
      this.setState({
        currentActionId: null,
        actionStartTime: null,
        highestActionCodeReached: 0,
        loading: false
      });
    }
  }

  extractActionId(response)
  {
    if (!response || !response.data) {
      return null;
    }

    const data = response.data;
    return (
      data.action_id ||
      data.actionId ||
      data.id ||
      (data.action && (data.action.id || data.action.action_id)) ||
      null
    );
  }

  extractActionIdFromHistoryResponse(response)
  {
    if (!response || !response.data) {
      return null;
    }

    const data = response.data;
    const firstAction = Array.isArray(data.results) ? data.results[0] : (Array.isArray(data) ? data[0] : data);
    if (!firstAction) {
      return null;
    }

    return firstAction.id || firstAction.action_id || null;
  }

  wait(ms)
  {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  async resolveActionIdWithHistoryFallback(initialActionId, panelId)
  {
    if (initialActionId) {
      return initialActionId;
    }

    const maxAttempts = 6;
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      if (attempt > 0) {
        // Backend kann die Action minimal verzögert im Verlauf anlegen.
        // Deshalb kurz warten und erneut versuchen.
        // eslint-disable-next-line no-await-in-loop
        await this.wait(2000);
      }

      // eslint-disable-next-line no-await-in-loop
      const historyResponse = await FireApi.endpoints.actionHistory.getOne(
        { id: panelId },
        {
          withCredentials: true,
          crossDomain: true,
          params: { page: 1, page_size: 1 }
        }
      );

      const historyActionId = this.extractActionIdFromHistoryResponse(historyResponse);
      if (historyActionId) {
        return historyActionId;
      }
    }

    return null;
  }

  sendRestart()
  {
    FireApi.endpoints.actionRestart.patch({ id: this.state.panel.id })
      .then(async (response) => {
        let actionId = this.extractActionId(response);
        actionId = await this.resolveActionIdWithHistoryFallback(actionId, this.state.panel.id);

        if(actionId) {
          this.startActionStatusPolling(actionId);
        } else {
          this.setState({
            alertText: 'Neustart gestartet, aber keine Action-ID erhalten. Status kann nicht abgefragt werden.',
            dialogAlert: true
          });
        }
        this.setState({ loading: false });
      })
      .catch((error) => {
        handleApiError(error, 'beim Neustart', () => {
          this.setState({ loading: false });
        });
      });

  }

  
  sendFirmwareWrite()
  {
    FireApi.endpoints.actionFirmwareWrite.patch({ id: this.state.panel.id })
      .then(async (response) => {
        let actionId = this.extractActionId(response);
        actionId = await this.resolveActionIdWithHistoryFallback(actionId, this.state.panel.id);

        if(actionId) {
          this.startActionStatusPolling(actionId);
        } else {
          this.setState({
            alertText: 'Firmware-Installation gestartet, aber keine Action-ID erhalten.',
            dialogAlert: true
          });
        }
        this.setState({ loading: false });
      })
      .catch((error) => {
        handleApiError(error, 'bei der Firmware-Installation', () => {
          this.setState({ loading: false });
        });
      });
  }

  sendFirmwareUpdate(version)
  {
    if(version !== 0)
    {
      this.setState((prev) => ({
        firmwareUpdate: { ...prev.firmwareUpdate, progress: 10 },
      }));

      FireApi.endpoints.actionFirmwareDownload.patch({ id: this.state.panel.id }, { id: version })
        .then(async (response) => {
          let actionId = this.extractActionId(response);
          actionId = await this.resolveActionIdWithHistoryFallback(actionId, this.state.panel.id);

          if(actionId) {
            this.startActionStatusPolling(actionId);
          } else {
            this.setState({
              alertText: 'Firmware-Download gestartet, aber keine Action-ID erhalten.',
              dialogAlert: true
            });
          }
          this.setState({ loading: false });
        })
        .catch((error) => {
          handleApiError(error, 'beim Firmware-Download', () => {
            this.setState({ loading: false });
          });
        });
    }
    else
    {
      this.setState({ alertText: 'Version Auswählen' });
      this.setState({ dialogAlert: true });
    }
    
  }

  getActionStatusUpdates()
  {
    if(!this.state.currentActionId) {
      return;
    }

    // Prüfe ob bereits die höchste Action-Nummer erreicht wurde (finale Status-Codes)
    // Erfolgreich: 3003 (Koffer neugestartet), 1004 (Download abgeschlossen), 1006 (CRC Korrekt), 2004 (Write abgeschlossen/written)
    // Fehler: 3004 (Neustart Fehler), 1005 (Download Fehler), 1007 (CRC Fehler), 2005 (Write Fehler), 2007 (Write CRC Fehler)
    // Hinweis: 2006 ist kein finaler Schritt, da 2004 (written) der finale Schritt bei Firmware-Installation ist
    if(this.state.highestActionCodeReached === 3003 || 
       this.state.highestActionCodeReached === 3004 ||
       this.state.highestActionCodeReached === 1004 || 
       this.state.highestActionCodeReached === 1005 || 
       this.state.highestActionCodeReached === 1006 ||
       this.state.highestActionCodeReached === 1007 ||
       this.state.highestActionCodeReached === 2004 || 
       this.state.highestActionCodeReached === 2005 ||
       this.state.highestActionCodeReached === 2007)
    {
      this.stopActionStatusPolling();
      return;
    }

    // Prüfe Timeout (5 Minuten = 300000ms)
    if(this.state.actionStartTime && (Date.now() - this.state.actionStartTime) > 300000)
    {
      const errorMessage = {
        time: new Date(),
        text: 'Aktion wurde nach 5 Minuten abgebrochen (Timeout)',
        last: 1,
        communicationId: 'timeout-' + Date.now()
      };
      this.setState((prev) => ({
        firmwareUpdateValues: [...(prev.firmwareUpdateValues || []), errorMessage],
        firmwareUpdate: { ...prev.firmwareUpdate, progress: 0 },
      }));
      this.stopActionStatusPolling();
      return;
    }

    this.setState((prev) => ({
      intervallFirmwareCurrent: prev.intervallFirmwareCurrent + 1,
    }));

    FireApi.endpoints.actionStatus.getOne({ id: this.state.currentActionId })
      .then((actionGet) => {
        if(actionGet && actionGet.data && !actionGet.error)
        {
          const actionData = actionGet.data;
          
          // Verarbeite alle Communications
          if(actionData.communications && Array.isArray(actionData.communications))
          {
            let maxContent = this.state.highestActionCodeReached;
            
            actionData.communications.forEach((communication) => {
              const content = communication.content;
              
              // Aktualisiere die höchste erreichte Action-Nummer
              if(content > maxContent) {
                maxContent = content;
              }
              
              // Prüfe ob diese Communication bereits verarbeitet wurde
              const alreadyProcessed = this.state.firmwareUpdateValues.some(
                (item) => item.communicationId === communication.id
              );

              if(!alreadyProcessed)
              {
                var send = 0;
                var isFinalAction = false;
                var firmwareProgress = this.state.firmwareUpdate.progress;

                switch (content)
                {
                  // Restart-Actions (3000er Bereich)
                  case 3001:
                    send = {
                      time: new Date(communication.created),
                      text: 'Anfrage',
                      last: 0,
                      communicationId: communication.id
                    };
                    break;
                  case 3002:
                    send = {
                      time: new Date(communication.created),
                      text: 'Empfangen',
                      last: 0,
                      communicationId: communication.id
                    };
                    break;
                  case 3003:
                    send = {
                      time: new Date(communication.created),
                      text: 'Neugestartet',
                      last: 1,
                      communicationId: communication.id
                    };
                    firmwareProgress = 100;
                    isFinalAction = true;
                    break;
                  case 3004:
                    send = {
                      time: new Date(communication.created),
                      text: 'Fehler',
                      last: 1,
                      communicationId: communication.id
                    };
                    firmwareProgress = 0;
                    isFinalAction = true;
                    break;

                  // Firmware-Download-Actions (1000er Bereich)
                  case 1001:
                    send = {
                      time: new Date(communication.created),
                      text: 'Anfrage',
                      last: 0,
                      communicationId: communication.id
                    };
                    firmwareProgress = 10;
                    break;
                  case 1002:
                    send = {
                      time: new Date(communication.created),
                      text: 'Empfangen',
                      last: 0,
                      communicationId: communication.id
                    };
                    firmwareProgress = 20;
                    break;
                  case 1003:
                    send = {
                      time: new Date(communication.created),
                      text: 'Lädt herunter',
                      last: 0,
                      communicationId: communication.id
                    };
                    firmwareProgress = 70;
                    break;
                  case 1004:
                    send = {
                      time: new Date(communication.created),
                      text: 'Abgeschlossen',
                      last: 1,
                      communicationId: communication.id
                    };
                    firmwareProgress = 100;
                    isFinalAction = true;
                    break;
                  case 1005:
                    send = {
                      time: new Date(communication.created),
                      text: 'Fehler',
                      last: 1,
                      communicationId: communication.id
                    };
                    firmwareProgress = 0;
                    isFinalAction = true;
                    break;
                  case 1006:
                    send = {
                      time: new Date(communication.created),
                      text: 'CRC Korrekt',
                      last: 1,
                      communicationId: communication.id
                    };
                    firmwareProgress = 100;
                    isFinalAction = true;
                    break;
                  case 1007:
                    send = {
                      time: new Date(communication.created),
                      text: 'CRC Fehler',
                      last: 1,
                      communicationId: communication.id
                    };
                    firmwareProgress = 0;
                    isFinalAction = true;
                    break;

                  // Firmware-Write-Actions (2000er Bereich)
                  case 2001:
                    send = {
                      time: new Date(communication.created),
                      text: 'Anfrage',
                      last: 0,
                      communicationId: communication.id
                    };
                    firmwareProgress = 10;
                    break;
                  case 2002:
                    send = {
                      time: new Date(communication.created),
                      text: 'Empfangen',
                      last: 0,
                      communicationId: communication.id
                    };
                    firmwareProgress = 20;
                    break;
                  case 2003:
                    send = {
                      time: new Date(communication.created),
                      text: 'Läuft',
                      last: 0,
                      communicationId: communication.id
                    };
                    firmwareProgress = 70;
                    break;
                  case 2004:
                    // Versuche Firmware-Version aus Communication-Daten oder State zu extrahieren
                    let versionInfo2004 = '';
                    if (communication.data && communication.data.version) {
                      versionInfo2004 = ` (Version ${communication.data.version})`;
                    } else if (this.state.firmware && this.state.firmware.length > 0) {
                      // Verwende die erste verfügbare Firmware-Version als Fallback
                      const latestFirmware = this.state.firmware[this.state.firmware.length - 1];
                      if (latestFirmware && latestFirmware.version) {
                        versionInfo2004 = ` (Version ${latestFirmware.version})`;
                      }
                    }
                    send = {
                      time: new Date(communication.created),
                      text: `Abgeschlossen${versionInfo2004}`,
                      last: 1,
                      communicationId: communication.id
                    };
                    firmwareProgress = 100;
                    isFinalAction = true;
                    break;
                  case 2005:
                    // Versuche Firmware-Version aus Communication-Daten oder State zu extrahieren
                    let versionInfo2005 = '';
                    if (communication.data && communication.data.version) {
                      versionInfo2005 = ` (Version ${communication.data.version})`;
                    } else if (this.state.firmware && this.state.firmware.length > 0) {
                      // Verwende die erste verfügbare Firmware-Version als Fallback
                      const latestFirmware = this.state.firmware[this.state.firmware.length - 1];
                      if (latestFirmware && latestFirmware.version) {
                        versionInfo2005 = ` (Version ${latestFirmware.version})`;
                      }
                    }
                    send = {
                      time: new Date(communication.created),
                      text: `Fehler${versionInfo2005}`,
                      last: 1,
                      communicationId: communication.id
                    };
                    firmwareProgress = 0;
                    isFinalAction = true;
                    break;
                  case 2006:
                    send = {
                      time: new Date(communication.created),
                      text: 'CRC Korrekt',
                      last: 0, // Kein finaler Schritt, da 2004 (written) der finale Schritt ist
                      communicationId: communication.id
                    };
                    firmwareProgress = 90; // Zwischenschritt
                    isFinalAction = false; // Nicht final, da 2004 der finale Schritt ist
                    break;
                  case 2007:
                    send = {
                      time: new Date(communication.created),
                      text: 'CRC Fehler',
                      last: 1,
                      communicationId: communication.id
                    };
                    firmwareProgress = 0;
                    isFinalAction = true;
                    break;
                  default:
                    break;
                }

                if(send !== 0)
                {
                  this.setState((prev) => ({
                    firmwareUpdateValues: [...(prev.firmwareUpdateValues || []), send],
                    firmwareUpdate: { ...prev.firmwareUpdate, progress: firmwareProgress },
                    loading: false,
                  }));
                }

                // Wenn die höchste Action-Nummer erreicht wurde, stoppe den Intervall
                if(isFinalAction)
                {
                  this.stopActionStatusPolling();
                }
              }
            });
            
            // Aktualisiere die höchste erreichte Action-Nummer
            if(maxContent > this.state.highestActionCodeReached) {
              this.setState({ highestActionCodeReached: maxContent });
              
              // Wenn die höchste Nummer erreicht wurde (finale Status-Codes), stoppe den Intervall
              // Erfolgreich: 3003, 1004, 1006, 2004 (2004 ist der finale Schritt bei Firmware-Installation)
              // Fehler: 3004, 1005, 1007, 2005, 2007
              // Hinweis: 2006 ist kein finaler Schritt, da 2004 (written) der finale Schritt ist
              if(maxContent === 3003 || maxContent === 3004 || maxContent === 1004 || maxContent === 1005 || maxContent === 1006 || maxContent === 1007 || maxContent === 2004 || maxContent === 2005 || maxContent === 2007) {
                this.stopActionStatusPolling();
              }
            }
          }
        }
      });
  }

  componentDidMount() {

    FireApi.endpoints.devices.getOne({ id: this.props.match.params.id })
      .then((panelGet) => {
        if(panelGet && !panelGet.error && panelGet.data)
        {
          // Unterstütze neues API-Format { count, page, results } und altes Format
          let panelData = panelGet.data;
          if (panelGet.data.results && Array.isArray(panelGet.data.results) && panelGet.data.results.length > 0) {
            panelData = panelGet.data.results[0];
          } else if (panelGet.data.results && Array.isArray(panelGet.data.results) && panelGet.data.results.length === 0) {
            // Keine Daten gefunden
            this.setState({ loading: false, loadingFlows: false });
            return;
          }
          
          this.setState({ panel: panelData });
          this.setState({ loading: false });
          this.setState({ loadingFlows: false });
        } else if (panelGet && panelGet.error) {
          // Fehler wurde bereits in catchFuntion behandelt
          this.setState({ loading: false });
          this.setState({ loadingFlows: false });
        } else {
          this.setState({ loading: false });
          this.setState({ loadingFlows: false });
        }
      })
      .catch((error) => {
        console.error('Fehler beim Laden des Panels:', error);
        this.setState({ loading: false });
        this.setState({ loadingFlows: false });
      });

      
    FireApi.endpoints.firmware.getAll()
      .then((panelGet) => {
        if(panelGet && !panelGet.error && panelGet.data)
        {
          let firmwareArray = [];
          
          if (Array.isArray(panelGet.data)) {
            firmwareArray = panelGet.data;
          } else if (panelGet.data && typeof panelGet.data === 'object' && panelGet.data !== null) {
            // Falls es ein einzelnes Objekt ist, konvertiere es zu einem Array
            firmwareArray = [panelGet.data];
          } else if (panelGet.data && panelGet.data.results && Array.isArray(panelGet.data.results)) {
            firmwareArray = panelGet.data.results;
          }
          
          // Stelle sicher, dass firmwareArray immer ein Array ist
          if (!Array.isArray(firmwareArray)) {
            firmwareArray = [];
          }
          
          this.setState({ firmware: firmwareArray });
          this.setState({ loading: false });
        } else if (panelGet && panelGet.error) {
          // Fehler wurde bereits in catchFuntion behandelt
          this.setState({ firmware: [], loading: false });
        } else {
          this.setState({ firmware: [], loading: false });
        }
      })
      .catch((error) => {
        console.error('Fehler beim Laden der Firmware:', error);
        this.setState({ firmware: [], loading: false });
      });

    // Lade initial Diagramm-Daten mit Standard-Zeitraum (letzte 10 Tage)
    this.loadChartData();

      FireApi.endpoints.devicesStatus.getOne({ id: this.props.match.params.id })
        .then((parkingGet) => {
          if(parkingGet && !parkingGet.error && parkingGet.data)
          {
            // Unterstütze neues API-Format { count, page, results } und altes Format
            let configData = parkingGet.data;
            if (parkingGet.data.results && Array.isArray(parkingGet.data.results) && parkingGet.data.results.length > 0) {
              configData = parkingGet.data.results[0];
            } else if (parkingGet.data.results && Array.isArray(parkingGet.data.results) && parkingGet.data.results.length === 0) {
              // Keine Daten gefunden
              this.setState({ loading: false });
              return;
            }
            
            this.setState({ configuration: configData });
            this.setState({ loading: false });
          } else if (parkingGet && parkingGet.error) {
            // Fehler wurde bereits in catchFuntion behandelt
            this.setState({ loading: false });
          } else {
            this.setState({ loading: false });
          }
        })
        .catch((error) => {
          console.error('Fehler beim Laden des Panel-Status:', error);
          this.setState({ loading: false });
        });

      // Lade Aktionsverlauf
      this.loadActionHistory();
      
      // Lade Panel-Logs
      this.loadDeviceLogs();
  }

  componentWillUnmount() {
    // Räume alle Intervals auf, um Memory Leaks zu vermeiden
    this.stopActionStatusPolling(false);
  }

  /**
   * Lädt Diagramm-Daten von der API mit Datumsfilterung
   */
  loadChartData() {
    const { chartDateFrom, chartDateTo } = this.state;
    
    // Formatiere Daten für API (YYYY-MM-DD)
    const dateFrom = chartDateFrom.format('YYYY-MM-DD');
    const dateTo = chartDateTo.format('YYYY-MM-DD');
    
    this.setState({ chartDataLoading: true });
    
    // Verwende spezielle Methode mit Datumsparametern
    FireApi.endpoints.devicesRequestList.getOneWithDateRange({ 
      id: this.props.match.params.id,
      dateFrom: dateFrom,
      dateTo: dateTo
    })
      .then((panelGet) => {
        if(panelGet && panelGet.data && Array.isArray(panelGet.data))
        {
          // Validiere Daten
          const validatedData = validateDeviceData(panelGet.data);

          // Verarbeite Diagramm-Daten
          this.processChartData(validatedData);

          if(validatedData.length > 0 && validatedData[0].quality !== undefined)
          {
            this.setState({ quality: validatedData[0].quality });
          }
        } else {
          this.setState({ chartTemperature: [], chartHumidity: [], chartDataLoading: false });
        }
      })
      .catch((error) => {
        handleApiError(error, 'beim Laden der Diagramm-Daten', () => {
          this.setState({ chartTemperature: [], chartHumidity: [], chartDataLoading: false });
        });
      });
  }

  /**
   * Reduziert Datenpunkte auf maximal 500 durch Durchschnittsbildung
   * Wenn mehr als 500 Datenpunkte vorhanden sind, werden benachbarte Punkte zu Durchschnitten zusammengefasst
   * @param {Array} data - Array von Datenpunkten (sortiert nach timestamp)
   * @param {number} maxPoints - Maximale Anzahl von Datenpunkten (Standard: 500)
   * @returns {Array} Reduziertes Array
   */
  reduceDataPoints(data, maxPoints = 500) {
    if (!data || !Array.isArray(data) || data.length <= maxPoints) {
      return data;
    }

    const reducedData = [];
    const groupSize = Math.ceil(data.length / maxPoints);

    for (let i = 0; i < data.length; i += groupSize) {
      const group = data.slice(i, Math.min(i + groupSize, data.length));
      
      if (group.length === 1) {
        reducedData.push(group[0]);
      } else {
        // Berechne Durchschnitt, Min, Max für die Gruppe
        let sum = 0;
        let min = Infinity;
        let max = -Infinity;
        let validCount = 0;
        let firstItem = group[0];
        let lastItem = group[group.length - 1];

        group.forEach(item => {
          const value = parseFloat(item.data);
          if (!isNaN(value)) {
            sum += value;
            min = Math.min(min, value);
            max = Math.max(max, value);
            validCount++;
          }
        });

        if (validCount > 0) {
          reducedData.push({
            date: firstItem.date || lastItem.date,
            time: firstItem.time || lastItem.time || (firstItem.date && lastItem.date ? `${firstItem.date} - ${lastItem.date}` : firstItem.date),
            data: Math.round((sum / validCount) * 10) / 10,
            timestamp: firstItem.timestamp || (group[0].timestamp + group[group.length - 1].timestamp) / 2,
            min: min !== Infinity ? Math.round(min * 10) / 10 : undefined,
            max: max !== -Infinity ? Math.round(max * 10) / 10 : undefined,
            count: validCount
          });
        }
      }
    }

    return reducedData;
  }

  /**
   * Verarbeitet Diagramm-Daten basierend auf ausgewähltem Zeitraum und Ansicht
   */
  processChartData(data) {
    if (!data || !Array.isArray(data) || data.length === 0) {
      this.setState({ chartTemperature: [], chartHumidity: [], chartDataLoading: false });
      return;
    }

    const { chartViewMode } = this.state;

    if (chartViewMode === 'daily') {
      // Tagesdurchschnitte für Trend über mehrere Tage
      this.processDailyTrends(data);
    } else {
      // Stündliche Daten für detaillierte Ansicht
      this.processHourlyData(data);
    }
    
    this.setState({ chartDataLoading: false });
  }

  /**
   * Verarbeitet Daten in 20-Minuten-Intervallen für Temperatur und Feuchtigkeit
   * Gruppiert Datenpunkte nach 20-Minuten-Intervallen und bildet Durchschnitte
   */
  processHourlyData(filteredData) {
    // Gruppiere Temperatur-Daten nach 20-Minuten-Intervallen
    const temperatureByInterval = {};
    
    filteredData
      .filter(item => item.value_t !== null && item.value_t !== undefined)
      .forEach(item => {
        try {
          const dateValue = item.created || item.value_created || item.value_r || item.timestamp;
          if (!dateValue) return;
          
          const date = dayjs(dateValue);
          if (!date.isValid()) return;
          
          // Runde auf 20-Minuten-Intervalle
          const roundedMinutes = Math.floor(date.minute() / 20) * 20;
          const roundedDate = date.minute(roundedMinutes).second(0).millisecond(0);
          const intervalKey = roundedDate.valueOf();
          
          if (!temperatureByInterval[intervalKey]) {
            temperatureByInterval[intervalKey] = {
              values: [],
              date: roundedDate
            };
          }
          
          const value = parseFloat(item.value_t);
          if (!isNaN(value)) {
            temperatureByInterval[intervalKey].values.push(value);
          }
        } catch (error) {
          console.error('Fehler beim Verarbeiten der Temperatur-Daten:', error);
        }
      });

    // Erstelle Datenpunkte mit Durchschnittswerten pro Intervall
    let temperatureStats = Object.keys(temperatureByInterval)
      .map(key => {
        const interval = temperatureByInterval[key];
        const avg = interval.values.reduce((sum, val) => sum + val, 0) / interval.values.length;
        
        return {
          date: interval.date.format('DD.MM. HH:mm'),
          time: interval.date.format('DD.MM.YYYY HH:mm'),
          data: Math.round(avg * 10) / 10,
          timestamp: interval.date.valueOf()
        };
      })
      .sort((a, b) => a.timestamp - b.timestamp);

    // Reduziere auf maximal 500 Datenpunkte
    temperatureStats = this.reduceDataPoints(temperatureStats, 500);

    // Gruppiere Luftfeuchtigkeit-Daten nach 20-Minuten-Intervallen
    const humidityByInterval = {};
    
    filteredData
      .filter(item => item.value_h !== null && item.value_h !== undefined)
      .forEach(item => {
        try {
          const dateValue = item.created || item.value_created || item.value_r || item.timestamp;
          if (!dateValue) return;
          
          const date = dayjs(dateValue);
          if (!date.isValid()) return;
          
          // Runde auf 20-Minuten-Intervalle
          const roundedMinutes = Math.floor(date.minute() / 20) * 20;
          const roundedDate = date.minute(roundedMinutes).second(0).millisecond(0);
          const intervalKey = roundedDate.valueOf();
          
          if (!humidityByInterval[intervalKey]) {
            humidityByInterval[intervalKey] = {
              values: [],
              date: roundedDate
            };
          }
          
          const value = parseFloat(item.value_h);
          if (!isNaN(value)) {
            humidityByInterval[intervalKey].values.push(value);
          }
        } catch (error) {
          console.error('Fehler beim Verarbeiten der Luftfeuchtigkeit-Daten:', error);
        }
      });

    // Erstelle Datenpunkte mit Durchschnittswerten pro Intervall
    let humidityStats = Object.keys(humidityByInterval)
      .map(key => {
        const interval = humidityByInterval[key];
        const avg = interval.values.reduce((sum, val) => sum + val, 0) / interval.values.length;
        
        return {
          date: interval.date.format('DD.MM. HH:mm'),
          time: interval.date.format('DD.MM.YYYY HH:mm'),
          data: Math.round(avg * 10) / 10,
          timestamp: interval.date.valueOf()
        };
      })
      .sort((a, b) => a.timestamp - b.timestamp);

    // Reduziere auf maximal 500 Datenpunkte
    humidityStats = this.reduceDataPoints(humidityStats, 500);

    this.setState({ chartTemperature: temperatureStats, chartHumidity: humidityStats });
  }

  /**
   * Verarbeitet Tagesdurchschnitte für Trend-Erkennung
   */
  processDailyTrends(filteredData) {
    if (!filteredData || filteredData.length === 0) {
      this.setState({ chartTemperature: [], chartHumidity: [] });
      return;
    }

    // Gruppiere nach Tagen
    const temperatureByDay = {};
    const humidityByDay = {};

    filteredData.forEach(item => {
      try {
        // Prüfe verschiedene mögliche Datumsfelder
        const dateValue = item.created || item.value_created || item.value_r || item.timestamp;
        if (!dateValue) return;
        
        const date = dayjs(dateValue);
        if (!date.isValid()) {
          console.warn('Ungültiges Datum:', dateValue, item);
          return;
        }
        
        const dayKey = date.format('YYYY-MM-DD');
        
        // Temperatur
        const tempValue = item.value_t;
        if (tempValue !== null && tempValue !== undefined && tempValue !== '') {
          const numValue = parseFloat(tempValue);
          if (!isNaN(numValue)) {
            if (!temperatureByDay[dayKey]) {
              temperatureByDay[dayKey] = { values: [], date: date };
            }
            temperatureByDay[dayKey].values.push(numValue);
          }
        }
        
        // Luftfeuchtigkeit
        const humValue = item.value_h;
        if (humValue !== null && humValue !== undefined && humValue !== '') {
          const numValue = parseFloat(humValue);
          if (!isNaN(numValue)) {
            if (!humidityByDay[dayKey]) {
              humidityByDay[dayKey] = { values: [], date: date };
            }
            humidityByDay[dayKey].values.push(numValue);
          }
        }
      } catch (error) {
        console.error('Fehler beim Gruppieren der Daten:', error, item);
      }
    });

    // Berechne Durchschnitte und Trends für Temperatur
    const temperatureStats = Object.keys(temperatureByDay)
      .sort()
      .map(dayKey => {
        const dayData = temperatureByDay[dayKey];
        if (dayData.values.length === 0) return null;
        
        const avg = dayData.values.reduce((sum, val) => sum + val, 0) / dayData.values.length;
        const min = Math.min(...dayData.values);
        const max = Math.max(...dayData.values);
        
        return {
          date: dayData.date.format('DD.MM.YYYY'),
          time: dayData.date.format('DD.MM.YYYY'),
          data: Math.round(avg * 10) / 10, // Auf 1 Dezimalstelle runden
          min: Math.round(min * 10) / 10,
          max: Math.round(max * 10) / 10,
          count: dayData.values.length,
          timestamp: dayData.date.startOf('day').valueOf()
        };
      })
      .filter(item => item !== null);

    // Berechne Durchschnitte und Trends für Luftfeuchtigkeit
    const humidityStats = Object.keys(humidityByDay)
      .sort()
      .map(dayKey => {
        const dayData = humidityByDay[dayKey];
        if (dayData.values.length === 0) return null;
        
        const avg = dayData.values.reduce((sum, val) => sum + val, 0) / dayData.values.length;
        const min = Math.min(...dayData.values);
        const max = Math.max(...dayData.values);
        
        return {
          date: dayData.date.format('DD.MM.YYYY'),
          time: dayData.date.format('DD.MM.YYYY'),
          data: Math.round(avg * 10) / 10,
          min: Math.round(min * 10) / 10,
          max: Math.round(max * 10) / 10,
          count: dayData.values.length,
          timestamp: dayData.date.startOf('day').valueOf()
        };
      })
      .filter(item => item !== null);

    this.setState({ chartTemperature: temperatureStats, chartHumidity: humidityStats });
  }

  /**
   * Handler für Datumsänderungen - lädt Daten neu von der API
   */
  handleDateFromChange = (newDate) => {
    const daysDiff = this.state.chartDateTo.diff(newDate, 'day');
    const newViewMode = daysDiff > 1 ? 'daily' : 'hourly';
    
    this.setState({ 
      chartDateFrom: newDate,
      chartViewMode: newViewMode
    }, () => {
      this.loadChartData();
    });
  }

  handleDateToChange = (newDate) => {
    const daysDiff = newDate.diff(this.state.chartDateFrom, 'day');
    const newViewMode = daysDiff > 1 ? 'daily' : 'hourly';
    
    this.setState({ 
      chartDateTo: newDate,
      chartViewMode: newViewMode
    }, () => {
      this.loadChartData();
    });
  }

  handleViewModeChange = (event) => {
    this.setState({ chartViewMode: event.target.value }, () => {
      // Bei Ansichtswechsel nur Daten neu verarbeiten, nicht neu laden
      // Falls rawChartData noch vorhanden ist, verwende es, sonst lade neu
      if (this.state.chartTemperature.length > 0 || this.state.chartHumidity.length > 0) {
        // Daten sind bereits geladen, nur Ansicht ändern
        // Lade Daten neu, um sicherzustellen dass alle Daten vorhanden sind
        this.loadChartData();
      } else {
        this.loadChartData();
      }
    });
  }

  /**
   * Lädt Panel-Logs von der API mit Pagination.
   * Es wird nur eine Seite geladen (z. B. 10–50 Einträge), nie tausende auf einmal.
   */
  loadDeviceLogs() {
    this.setState({ panelLogsLoading: true });
    
    const { panelLogsPage, panelLogsRowsPerPage, hideHealthChecks } = this.state;
    
    // health_checks: 'all' | 'none' | 'last' – API filtert Health-Checks serverseitig
    const config = {
      withCredentials: true,
      crossDomain: true,
      params: {
        page: panelLogsPage + 1,
        page_size: panelLogsRowsPerPage,
        health_checks: hideHealthChecks ? 'last' : 'all'
      }
    };
    
    FireApi.endpoints.deviceLogs.getOne({ id: this.props.match.params.id }, config)
      .then((response) => {
        if (response && !response.error && response.data) {
          let logsArray = [];
          let totalCount = 0;
          
          // Unterstütze neues API-Format { count, page, results } und altes Format
          if (response.data.results && Array.isArray(response.data.results)) {
            logsArray = response.data.results;
            totalCount = response.data.count || response.data.results.length;
          } else if (Array.isArray(response.data)) {
            logsArray = response.data;
            totalCount = response.data.length;
          }
          
          // Verarbeite Logs
          const processedLogs = logsArray.map((log) => {
            return this.processLog(log);
          }).sort((a, b) => {
            // Sortiere nach Datum (neueste zuerst)
            return new Date(b.created) - new Date(a.created);
          });

          // Zähle unbestätigte wichtige Logs (importance >= 1)
          const unconfirmedCount = processedLogs.filter(log => 
            log.importance >= 1 && !log.confirmed
          ).length;

          this.setState({ 
            panelLogs: processedLogs,
            unconfirmedImportantLogsCount: unconfirmedCount,
            panelLogsTotalCount: totalCount,
            panelLogsLoading: false 
          });
        } else if (response && response.error) {
          // Fehler wurde bereits in catchFuntion behandelt
          this.setState({ panelLogsLoading: false });
        } else {
          this.setState({ panelLogsLoading: false });
        }
      })
      .catch((error) => {
        console.error('Fehler beim Laden der Panel-Logs:', error);
        this.setState({ panelLogsLoading: false });
      });
  }

  processLog(log)
  {
    const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';
    const importanceLevels = {
      0: { text: 'Unwichtig', color: isDarkMode ? '#9ca3af' : '#666' },
      1: { text: 'Wichtig', color: '#ff9800' },
      2: { text: 'Sehr wichtig', color: '#f44336' },
      3: { text: 'Alarm', color: '#c24141' }
    };

    const messageTexts = {
      1: 'Display-Fehler',
      2: 'Download-Fehler',
      3: 'CRC-Download-Fehler',
      4: 'Firmware-Installationsfehler',
      5: 'Firmware-CRC-Fehler',
      6: 'SD-Kartenfehler',
      7: 'Sensorfehler',
      8: 'Health-Check',
      1107: 'Feueralarm'
    };
    const code = Number(log.message);
    let messageText = log.message_name;
    if (!messageText || messageText === 'Unknown') {
      messageText = messageTexts[code] || `Unbekannt (${log.message})`;
    }

    return {
      id: log.id,
      created: log.created,
      message: messageText,
      messageCode: Number.isFinite(code) ? code : log.message,
      importance: log.importance,
      importanceText: importanceLevels[log.importance]?.text || 'Unbekannt',
      importanceColor: importanceLevels[log.importance]?.color || '#666',
      confirmed: log.confirmed === true || log.confirmed === 1,
      confirmable: log.confirmable !== false,
      type: log.type,
      confirmedBy: log.confirmed_by,
      log: log // Gesamte Log-Daten
    };
  }

  confirmLog(logId)
  {
    this.setState({ confirmingLogId: logId });
    FireApi.endpoints.deviceLogs.confirm({ id: logId })
      .then((res) => {
        const data = res?.data || {};
        if (res?.error || data.status === 'error' || data.rights === 'error') {
          this.setState({ confirmingLogId: null });
          return;
        }
        if (data.status === 'blocked') {
          this.setState({ confirmingLogId: null });
          if (window.showErrorNotification) {
            window.showErrorNotification(data.message || 'Alarm ist noch aktiv. Bestätigen nicht möglich.', 'warning');
          }
          return;
        }
        this.setState((prev) => {
          const panelLogs = prev.panelLogs.map((log) => (
            log.id === logId
              ? {
                  ...log,
                  confirmed: true,
                  confirmedBy: data.confirmed_by || log.confirmedBy,
                  log: {
                    ...(log.log || {}),
                    confirmed: true,
                    confirmed_by: data.confirmed_by || log.log?.confirmed_by,
                  },
                }
              : log
          ));
          return {
            confirmingLogId: null,
            panelLogs,
            unconfirmedImportantLogsCount: panelLogs.filter((log) => log.importance >= 1 && !log.confirmed).length,
          };
        });
      })
      .catch(() => {
        this.setState({ confirmingLogId: null });
      });
  }

  /**
   * Lädt Aktionsverlauf von der API mit Pagination
   */
  loadActionHistory() {
    this.setState({ actionHistoryLoading: true });
    
    const { actionHistoryPage, actionHistoryRowsPerPage } = this.state;
    
    // Rufe Aktionsverlauf für dieses Koffer ab mit Pagination
    // Verwende getOne mit Koffer-ID - Pagination wird als Query-Parameter übergeben
    const config = {
      withCredentials: true,
      crossDomain: true,
      params: {
        page: actionHistoryPage + 1,
        page_size: actionHistoryRowsPerPage
      }
    };
    
    FireApi.endpoints.actionHistory.getOne({ id: this.props.match.params.id }, config)
      .then((response) => {
        if (response && !response.error && response.data) {
          let historyArray = [];
          let totalCount = 0;
          
          // Unterstütze neues API-Format { count, page, results } und altes Format
          if (response.data.results && Array.isArray(response.data.results)) {
            historyArray = response.data.results;
            totalCount = response.data.count || response.data.results.length;
          } else if (Array.isArray(response.data)) {
            historyArray = response.data;
            totalCount = response.data.length;
          }
          
          // Verarbeite Aktionen und erstelle Verlauf
          const processedHistory = historyArray.map((action) => {
            return this.processActionForHistory(action);
          }).sort((a, b) => {
            // Sortiere nach Datum (neueste zuerst)
            return new Date(b.created) - new Date(a.created);
          });

          this.setState({ 
            actionHistory: processedHistory,
            actionHistoryTotalCount: totalCount,
            actionHistoryLoading: false 
          });
        } else if (response && response.error) {
          // Fehler wurde bereits in catchFuntion behandelt
          this.setState({ actionHistoryLoading: false });
        } else {
          this.setState({ actionHistoryLoading: false });
        }
      })
      .catch((error) => {
        console.error('Fehler beim Laden des Aktionsverlaufs:', error);
        this.setState({ actionHistoryLoading: false });
      });
  }

  processActionForHistory(action)
  {
    // Bestimme Aktionstyp basierend auf value-Feld
    // value: 1 = Firmware Download, 2 = Firmware Installation, 3 = Neustart
    let actionType = 'Unbekannt';
    let status = 'Unbekannt';
    let success = false;
    let details = '';

    switch(action.value) {
      case 1:
        actionType = 'Firmware Download';
        // Feld 'a' enthält möglicherweise die Firmware-Version
        if (action.a) {
          details = `Version ${action.a}`;
        }
        break;
      case 2:
        actionType = 'Firmware Installation';
        // Feld 'a' könnte die installierte Version enthalten
        if (action.a) {
          details = `Version ${action.a}`;
        }
        break;
      case 3:
        actionType = 'Neustart';
        break;
      default:
        actionType = `Aktion ${action.value}`;
    }

    // Bestimme Status basierend auf last_step, falls verfügbar
    // last_step enthält den letzten Step mit content-Code
    if (action.last_step && action.last_step.content !== undefined) {
      const lastStepContent = action.last_step.content;
      const lastStepTime = action.last_step.created ? new Date(action.last_step.created) : null;
      const now = new Date();
      const fiveMinutesAgo = new Date(now.getTime() - 5 * 60 * 1000); // 5 Minuten in Millisekunden
      
      // Erfolgreiche finale Status-Codes
      // 3003: Koffer neugestartet (Neustart erfolgreich)
      // 1004: Firmware-Download abgeschlossen (Download erfolgreich)
      // 1006: Firmware-Download CRC Korrekt (CRC-OK)
      // 2004: Firmware-Write abgeschlossen (written) - Finaler Schritt bei Firmware-Installation
      if ([3003, 1004, 1006, 2004].includes(lastStepContent)) {
        success = true;
        status = 'Erfolgreich';
      }
      // Fehler-Status-Codes
      // 3004: Koffer neustart fehler
      // 1005: Firmware-Download Fehler
      // 1007: Firmware-Download CRC Fehler
      // 2005: Firmware-Write Fehler
      // 2007: Firmware-Write CRC Fehler
      else if ([3004, 1005, 1007, 2005, 2007].includes(lastStepContent)) {
        success = false;
        status = 'Fehlgeschlagen';
      }
      // Zwischenschritte - nur "In Bearbeitung" wenn innerhalb der letzten 5 Minuten
      // 1001, 1002, 1003: Firmware Download Zwischenschritte
      // 2001, 2002, 2003, 2006: Firmware Write Zwischenschritte (2006 ist kein finaler Schritt)
      // 3001, 3002: Neustart Zwischenschritte
      else {
        // Prüfe ob die letzte Aktion innerhalb der letzten 5 Minuten war
        if (lastStepTime && lastStepTime >= fiveMinutesAgo) {
          success = null;
          status = 'In Bearbeitung';
        } else {
          // Zu alt oder kein Zeitstempel - Status unbekannt
          success = false;
          status = 'Abgebrochen';
        }
      }
    } 
    // Fallback: Versuche Status aus Steps zu bestimmen (für Rückwärtskompatibilität)
    else if (action.steps && Array.isArray(action.steps) && action.steps.length > 0) {
      const lastStep = action.steps[action.steps.length - 1];
      const finalContent = lastStep.content;
      const lastStepTime = lastStep.created ? new Date(lastStep.created) : null;
      const now = new Date();
      const fiveMinutesAgo = new Date(now.getTime() - 5 * 60 * 1000); // 5 Minuten in Millisekunden
      
      if ([3003, 1004, 1006, 2004].includes(finalContent)) {
        success = true;
        status = 'Erfolgreich';
      } else if ([3004, 1005, 1007, 2005, 2007].includes(finalContent)) {
        success = false;
        status = 'Fehlgeschlagen';
      } else {
        // Zwischenschritt - nur "In Bearbeitung" wenn innerhalb der letzten 5 Minuten
        if (lastStepTime && lastStepTime >= fiveMinutesAgo) {
          success = null;
          status = 'In Bearbeitung';
        } else {
          // Zu alt oder kein Zeitstempel - Status unbekannt
          success = false;
          status = 'Abgebrochen';
        }
      }
    } 
    // Fallback: Wenn last_step null ist, als Fehlgeschlagen behandeln
    else {
      success = false;
      status = 'Fehlgeschlagen';
    }

    // Versuche Benutzer-Informationen zu extrahieren
    let user = 'System';
    if (action.user) {
      if (typeof action.user === 'string') {
        user = action.user;
      } else {
        user = action.user.username || action.user.email || 'Unbekannt';
      }
    }

    return {
      id: action.id,
      type: actionType,
      status: status,
      success: success,
      user: user,
      created: action.created,
      details: details,
      action: action // Gesamte Action-Daten für Details
    };
  }

  render() {
    return (
      <SecuredZone 
        title={this.state.panel.name || this.state.configuration.name || 'Koffer'}
        breadcrumbs={{ '/': 'Dashboard', '/devices':'Koffer', [`/devices/${this.props.match.params.id}`] : `${this.state.panel.name || 'Koffer'}` }}
        menu={{ 'Löschen': this.handleClickDelete.bind(this),'Bearbeiten': this.handleClickOpen.bind(this) }}
        loading={ this.state.loading ? <LinearProgress color="primary" /> : <span className="loader-span"></span> }
      >
        <Dialog 
          open={this.state.dialogOpen} 
          onClose={this.handleClose.bind(this)}
          PaperProps={{
            sx: {
              borderRadius: '12px',
              transition: 'all 0.3s ease'
            }
          }}
        >
          <DeviceDialog panelData={this.state.panel} close={this.handleClose.bind(this)} submit={this.submitDialog.bind(this)}/>
        </Dialog>
        <Dialog
          open={this.state.dialogAlert}
          onClose={this.handleCloseAlert.bind(this)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            sx: {
              borderRadius: '12px',
              transition: 'all 0.3s ease'
            }
          }}
        >
          <DialogTitle id="alert-dialog-title">
            {"Meldung"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.alertText}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleCloseAlert()}>Schliessen</Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.actionDetailsDialogOpen}
          onClose={this.handleCloseActionDetails.bind(this)}
          maxWidth="md"
          fullWidth
          aria-labelledby="action-details-dialog-title"
          PaperProps={{
            sx: {
              borderRadius: '12px',
              transition: 'all 0.3s ease'
            }
          }}
        >
          <DialogTitle id="action-details-dialog-title">
            Aktionsdetails
          </DialogTitle>
          <DialogContent>
            {this.state.actionDetailsLoading ? (
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <LinearProgress />
                <div style={{ 
                  marginTop: '10px', 
                  color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#666',
                  transition: 'color 0.3s ease'
                }}>Lade Details...</div>
              </div>
            ) : this.state.selectedActionDetails ? (
              <DisplayActionDetails details={this.state.selectedActionDetails} panelVersion={this.state.panel.version} />
            ) : null}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseActionDetails.bind(this)}>Schliessen</Button>
          </DialogActions>
        </Dialog>

        {(() => {
          const cfg = this.state.configuration || {};
          const panel = this.state.panel || {};
          const lastSeen = cfg.value_created ? moment(cfg.value_created) : null;
          const online = lastSeen ? Date.now() - lastSeen.valueOf() < ONLINE_THRESHOLD_MS : false;
          const temp = fmtNum(cfg.value_t);
          const humidity = fmtNum(cfg.value_h);
          const battery = fmtNum(cfg.value_a);
          const signal = fmtNum(cfg.value_s, 0);
          const ports = [
            portMeta(panel.port_1 || cfg.port_1, cfg.value_o),
            portMeta(panel.port_2 || cfg.port_2, cfg.value_j),
            portMeta(panel.port_3 || cfg.port_3, cfg.value_e),
            portMeta(panel.port_4 || cfg.port_4, cfg.value_p),
          ];
          const alarmCount = ports.filter((p) => p.alarm).length;
          const portIcon = (kind) => {
            if (kind === 'fire') return <Icon name="fire" size={24} />;
            if (kind === 'door') return <Icon name="door" size={24} />;
            return <Icon name="emptyPort" size={24} />;
          };

          return (
            <>
              <Card
                width="1"
                title="Koffer"
                data={
                  <div className="ko-hero">
                    <div className="ko-hero-left">
                      <div className="ko-hero-name">{panel.name || cfg.name || 'Koffer'}</div>
                      <div className="ko-hero-meta">
                        <span className={`ko-pill ${online ? 'is-online' : 'is-offline'}`}>
                          <Icon name={online ? 'online' : 'offline'} size={20} />
                          {online ? 'Online' : 'Offline'}
                        </span>
                        {alarmCount > 0 && (
                          <span className="ko-pill is-alarm">
                            <Icon name="alarm" size={20} />
                            {alarmCount} Alarm
                          </span>
                        )}
                        <span className="ko-pill">
                          <Icon name="time" size={20} />
                          {lastSeen ? lastSeen.format('DD.MM.YYYY HH:mm') : '–'}
                        </span>
                        {panel.uuid && (
                          <span className="ko-hero-uuid">
                            <Icon name="uuid" size={20} /> {panel.uuid}
                          </span>
                        )}
                      </div>
                    </div>
                    <div>
                      <Switch
                        checked={!!panel.active}
                        onChange={(event, data) => this.statusChange(data)}
                        color="primary"
                      />
                      <span style={{ color: 'var(--text-secondary)', fontSize: 13, fontWeight: 600 }}>
                        {panel.active ? 'Aktiv' : 'Inaktiv'}
                      </span>
                    </div>
                  </div>
                }
              />

              <Card
                width="1"
                title="Messwerte"
                data={
                  <div className="ko-metrics">
                    <div className="ko-metric">
                      <div className="ko-metric-label">
                        <Icon name="temperature" size={22} /> Temperatur
                      </div>
                      <div className="ko-metric-value">
                        {temp === null ? '–' : temp.toFixed(1)}
                        {temp !== null && <span className="ko-metric-unit">°C</span>}
                      </div>
                    </div>
                    <div className="ko-metric">
                      <div className="ko-metric-label">
                        <Icon name="humidity" size={22} /> Luftfeuchtigkeit
                      </div>
                      <div className="ko-metric-value">
                        {humidity === null ? '–' : humidity.toFixed(0)}
                        {humidity !== null && <span className="ko-metric-unit">%</span>}
                      </div>
                    </div>
                    <div className="ko-metric">
                      <div className="ko-metric-label">
                        <Icon name="battery" size={22} /> Batterie
                      </div>
                      <div className="ko-metric-value">
                        {battery === null ? '–' : battery.toFixed(1)}
                        {battery !== null && <span className="ko-metric-unit">V</span>}
                      </div>
                    </div>
                    <div className="ko-metric">
                      <div className="ko-metric-label">
                        <Icon name="signal" size={22} /> GSM-Signal
                      </div>
                      <div className="ko-metric-value">
                        {signal === null ? '–' : signal.toFixed(0)}
                      </div>
                    </div>
                  </div>
                }
              />

              <Card
                width="1"
                title="Anschlüsse"
                data={
                  <div className="ko-ports">
                    {ports.map((port, idx) => (
                      <div
                        key={idx}
                        className={`ko-port${port.alarm ? ' is-alarm' : port.state === 'OK' ? ' is-ok' : ''}`}
                      >
                        <div className="ko-port-top">
                          <span>Anschluss {idx + 1}</span>
                          {portIcon(port.kind)}
                        </div>
                        <div className="ko-port-type">{port.label}</div>
                        <div className="ko-port-state">
                          {port.state === 'OK' && <Icon name="ok" size={22} />}
                          {port.state === 'Alarm' && <Icon name="alarm" size={22} />}
                          {port.state === 'Nicht belegt' && <Icon name="emptyPort" size={22} />}
                          {port.state}
                        </div>
                      </div>
                    ))}
                  </div>
                }
              />

              <Card
                width="2-4"
                title="Standort"
                data={
                  this.state.loading ? (
                    <LinearProgress />
                  ) : (
                    <DisplayCardLocation panel={{ ...cfg, name: panel.name || cfg.name, active: panel.active }} />
                  )
                }
              />
              <Card
                width="2-4"
                title="Status"
                data={<DisplayCardStatus statusChange={this.statusChange.bind(this)} data={panel} />}
              />
            </>
          );
        })()}
        { this.state.loading ?
          <div className="card-container card-1" style={{ minHeight: '220px', opacity: 0.6 }}>
            <div className="card-container-title">
              <div className="card-container-text">Aktionen</div>
            </div>
            <div style={{ height: '360px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <LinearProgress style={{ width: '80%' }} />
            </div>
          </div>
          :
          <Card width="1" title="Aktionen" data=<DisplayCardAction history={this.state.firmwareUpdateValues} sendFirmwareWrite={this.sendFirmwareWrite.bind(this)} sendRestart={this.sendRestart.bind(this)} sendFirmwareUpdate={this.sendFirmwareUpdate.bind(this)} this={this} action={this.state.actionSet}/>/>
        }
        { this.state.loading ?
          <div className="card-container card-1" style={{ minHeight: '300px', opacity: 0.6, animation: 'fadeIn 0.5s ease-in' }}>
            <div className="card-container-title">
              <div className="card-container-text">Aktionsverlauf</div>
            </div>
            <div style={{ height: '260px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <LinearProgress style={{ width: '80%' }} />
            </div>
          </div>
          :
          <Card width="1" title="Aktionsverlauf" data={<DisplayCardActionHistory 
            history={this.state.actionHistory} 
            loading={this.state.actionHistoryLoading} 
            totalCount={this.state.actionHistoryTotalCount}
            page={this.state.actionHistoryPage}
            rowsPerPage={this.state.actionHistoryRowsPerPage}
            onShowDetails={this.handleOpenActionDetails.bind(this)}
            onPageChange={this.handleActionHistoryChangePage}
            onRowsPerPageChange={this.handleActionHistoryChangeRowsPerPage}
          />} />
        }
        { this.state.loading ?
          <div className="card-container card-1" style={{ minHeight: '300px', opacity: 0.6, animation: 'fadeIn 0.5s ease-in' }}>
            <div className="card-container-title">
              <div className="card-container-text">Koffer Logs</div>
            </div>
            <div style={{ height: '260px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <LinearProgress style={{ width: '80%' }} />
            </div>
          </div>
          :
          <Card
            width="1"
            title="Koffer Logs"
            add={
              <Button
                size="small"
                variant="text"
                color="primary"
                sx={{ minHeight: 32, height: 32, px: 1.5 }}
                onClick={() => this.setState({ hideHealthChecks: !this.state.hideHealthChecks }, () => this.loadDeviceLogs())}
              >
                {this.state.hideHealthChecks ? 'Alle Logs anzeigen' : 'Nur letzten Health-Check'}
              </Button>
            }
            data={<DisplayCardDeviceLogs 
            logs={this.state.panelLogs} 
            loading={this.state.panelLogsLoading} 
            totalCount={this.state.panelLogsTotalCount}
            page={this.state.panelLogsPage}
            rowsPerPage={this.state.panelLogsRowsPerPage}
            onConfirm={this.confirmLog.bind(this)}
            confirmingId={this.state.confirmingLogId}
            onPageChange={this.handleDeviceLogsChangePage}
            onRowsPerPageChange={this.handleDeviceLogsChangeRowsPerPage}
            hideHealthChecks={this.state.hideHealthChecks}
          />} />
        }
        { this.state.loading ?
          <div className="card-container card-1" style={{ height: '400px', minHeight: '400px' }}>
            <div className="card-container-title">
              <div className="card-container-text">Diagramme</div>
            </div>
            <div style={{ height: '360px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <LinearProgress style={{ width: '100%' }} />
            </div>
          </div>
          :
          <Card width="1" title="Diagramme" data={
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ 
                mb: 2, 
                p: 2.5, 
                transition: 'all 0.3s ease'
              }}>
                  <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center', mb: 2 }}>
                    <DatePicker
                      label="Von"
                      value={this.state.chartDateFrom}
                      onChange={this.handleDateFromChange}
                      maxDate={this.state.chartDateTo}
                      format="DD.MM.YYYY"
                      slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
                    />
                    <DatePicker
                      label="Bis"
                      value={this.state.chartDateTo}
                      onChange={this.handleDateToChange}
                      minDate={this.state.chartDateFrom}
                      maxDate={dayjs()}
                      format="DD.MM.YYYY"
                      slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
                    />
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                      <Button 
                        size="small" 
                        variant="outlined"
                        sx={{
                          textTransform: 'none',
                          borderRadius: '8px',
                          fontWeight: 500,
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            transform: 'translateY(-1px)',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                          }
                        }}
                        onClick={() => {
                          this.setState({
                            chartDateFrom: dayjs().subtract(1, 'day'),
                            chartDateTo: dayjs(),
                            chartViewMode: 'hourly'
                          }, () => {
                            this.loadChartData();
                          });
                        }}
                      >
                        Heute
                      </Button>
                      <Button 
                        size="small" 
                        variant="outlined"
                        sx={{
                          textTransform: 'none',
                          borderRadius: '8px',
                          fontWeight: 500,
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            transform: 'translateY(-1px)',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                          }
                        }}
                        onClick={() => {
                          this.setState({
                            chartDateFrom: dayjs().subtract(7, 'day'),
                            chartDateTo: dayjs(),
                            chartViewMode: 'daily'
                          }, () => {
                            this.loadChartData();
                          });
                        }}
                      >
                        7 Tage
                      </Button>
                      <Button 
                        size="small" 
                        variant="outlined"
                        sx={{
                          textTransform: 'none',
                          borderRadius: '8px',
                          fontWeight: 500,
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            transform: 'translateY(-1px)',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                          }
                        }}
                        onClick={() => {
                          this.setState({
                            chartDateFrom: dayjs().subtract(10, 'day'),
                            chartDateTo: dayjs(),
                            chartViewMode: 'daily'
                          }, () => {
                            this.loadChartData();
                          });
                        }}
                      >
                        10 Tage
                      </Button>
                      <Button 
                        size="small" 
                        variant="outlined"
                        sx={{
                          textTransform: 'none',
                          borderRadius: '8px',
                          fontWeight: 500,
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            transform: 'translateY(-1px)',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                          }
                        }}
                        onClick={() => {
                          this.setState({
                            chartDateFrom: dayjs().subtract(30, 'day'),
                            chartDateTo: dayjs(),
                            chartViewMode: 'daily'
                          }, () => {
                            this.loadChartData();
                          });
                        }}
                      >
                        30 Tage
                      </Button>
                      <Button 
                        size="small" 
                        variant="outlined"
                        sx={{
                          textTransform: 'none',
                          borderRadius: '8px',
                          fontWeight: 500,
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            transform: 'translateY(-1px)',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                          }
                        }}
                        onClick={() => {
                          this.setState({
                            chartDateFrom: dayjs().subtract(90, 'day'),
                            chartDateTo: dayjs(),
                            chartViewMode: 'daily'
                          }, () => {
                            this.loadChartData();
                          });
                        }}
                      >
                        90 Tage
                      </Button>
                    </Box>
                  </Box>
                  <Typography 
                    variant="caption" 
                    sx={{ 
                      color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#6b7280',
                      fontSize: '0.75rem',
                      fontWeight: 500,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                      transition: 'color 0.3s ease'
                    }}
                  >
                    {this.state.chartDataLoading ? (
                      <span>Lade Daten...</span>
                    ) : (
                      <>
                        <span>{this.state.chartDateFrom.format('DD.MM.YYYY')} - {this.state.chartDateTo.format('DD.MM.YYYY')}</span>
                        {this.state.chartViewMode === 'daily' && (
                          <span style={{ 
                            marginLeft: '8px', 
                            padding: '2px 8px', 
                            backgroundColor: document.documentElement.getAttribute('data-theme') === 'dark' ? '#1e1e3a' : '#e0e7ff', 
                            borderRadius: '4px', 
                            color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#818cf8' : '#6366f1',
                            transition: 'all 0.3s ease'
                          }}>Tages-Trend</span>
                        )}
                        {this.state.chartViewMode === 'hourly' && (
                          <span style={{ 
                            marginLeft: '8px', 
                            padding: '2px 8px', 
                            backgroundColor: document.documentElement.getAttribute('data-theme') === 'dark' ? '#3a2e1f' : '#fef3c7', 
                            borderRadius: '4px', 
                            color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#fbbf24' : '#d97706',
                            transition: 'all 0.3s ease'
                          }}>20-Min-Intervalle</span>
                        )}
                      </>
                    )}
                  </Typography>
                </Box>
              </LocalizationProvider>
          }/>
        }
        <Card width="1" title="Temperatur" data={
          <div style={{ height: '360px', overflow: 'visible', position: 'relative' }}>
            {this.state.loading ? (
              <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <LinearProgress style={{ width: '100%' }} />
              </div>
            ) : this.state.chartDataLoading ? (
              <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', animation: 'fadeIn 0.3s ease-in' }}>
                <LinearProgress style={{ width: '100%' }} />
              </div>
            ) : (
              <div style={{ height: '360px', width: '100%', position: 'relative', overflow: 'visible', animation: 'fadeIn 0.5s ease-in', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {Array.isArray(this.state.chartTemperature) && this.state.chartTemperature.length > 0 ? (
                  <DisplayCardChartsTemperature chartdat={this.state.chartTemperature} viewMode={this.state.chartViewMode} />
                ) : (
                  <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center', 
                    justifyContent: 'center',
                    textAlign: 'center'
                  }}>
                    <ThermostatIcon sx={{ 
                      fontSize: '64px', 
                      color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#4a5568' : '#cbd5e1',
                      marginBottom: '16px',
                      opacity: 0.5
                    }} />
                    <div style={{ 
                      fontSize: '18px',
                      fontWeight: 500,
                      color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#9ca3af' : '#6b7280',
                      marginBottom: '8px',
                      transition: 'color 0.3s ease'
                    }}>
                      Keine Daten verfügbar
                    </div>
                    <div style={{ 
                      fontSize: '14px',
                      color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#6b7280' : '#9ca3af',
                      transition: 'color 0.3s ease'
                    }}>
                      Es wurden noch keine Temperaturdaten erfasst
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        }/>
        <Card width="1" title="Feuchtigkeit" data={
          <div style={{ height: '360px', overflow: 'visible', position: 'relative' }}>
            {this.state.loading ? (
              <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <LinearProgress style={{ width: '100%' }} />
              </div>
            ) : this.state.chartDataLoading ? (
              <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', animation: 'fadeIn 0.3s ease-in' }}>
                <LinearProgress style={{ width: '100%' }} />
              </div>
            ) : (
              <div style={{ height: '360px', width: '100%', position: 'relative', overflow: 'visible', animation: 'fadeIn 0.5s ease-in', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {Array.isArray(this.state.chartHumidity) && this.state.chartHumidity.length > 0 ? (
                  <DisplayCardChartsHumidity chartdat={this.state.chartHumidity} viewMode={this.state.chartViewMode} />
                ) : (
                  <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center', 
                    justifyContent: 'center',
                    textAlign: 'center'
                  }}>
                    <WaterDropIcon sx={{ 
                      fontSize: '64px', 
                      color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#4a5568' : '#cbd5e1',
                      marginBottom: '16px',
                      opacity: 0.5
                    }} />
                    <div style={{ 
                      fontSize: '18px',
                      fontWeight: 500,
                      color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#9ca3af' : '#6b7280',
                      marginBottom: '8px',
                      transition: 'color 0.3s ease'
                    }}>
                      Keine Daten verfügbar
                    </div>
                    <div style={{ 
                      fontSize: '14px',
                      color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#6b7280' : '#9ca3af',
                      transition: 'color 0.3s ease'
                    }}>
                      Es wurden noch keine Feuchtigkeitsdaten erfasst
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        }/>
      </SecuredZone>
    );
  }
}

export function DisplayCardStatus(props) {
  return (
    <div className="ko-status-fill">
      <div>
        <div className="ko-status-label">Betrieb</div>
        <div className="ko-status-value">
          {props.data.active ? 'Aktiv' : 'Inaktiv'}
        </div>
      </div>
      <Switch checked={!!props.data.active} onChange={(event, data) => { props.statusChange(data); }} color="primary" />
    </div>
  );
}

export function DisplayCardAction(props) {

  const [currentVersion, setCurrentVersion] = useState(0);

  const getActionButtonStyle = (actionSet, targetSet) => {
    return {
      minHeight: '44px',
      fontSize: '14px',
      fontWeight: actionSet === targetSet ? 600 : 500,
    };
  };

  return (
    <div style={{ 
      display: 'flex', 
      gap: '16px', 
      minHeight: 0,
      padding: '4px 0'
    }}>
      {/* Linke Sidebar mit Aktions-Buttons */}
      <div style={{ 
        width: '220px', 
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
      }}>
        <Button 
          onClick={() => props.this.handleActionSetChange(1)} 
          startIcon={<RestartAltIcon />} 
          color="info" 
          variant={props.this.state.actionSet === 1 ? "contained" : "outlined"}
          fullWidth
          style={getActionButtonStyle(props.this.state.actionSet, 1)}
        >
          Neustarten
        </Button>
        <Button 
          onClick={() => props.this.handleActionSetChange(2)} 
          startIcon={<CloudDownloadIcon />} 
          color="secondary" 
          variant={props.this.state.actionSet === 2 ? "contained" : "outlined"}
          fullWidth
          style={getActionButtonStyle(props.this.state.actionSet, 2)}
        >
          Firmware Übertragen
        </Button>
        <Button 
          onClick={() => props.this.handleActionSetChange(3)} 
          startIcon={<SystemUpdateAltIcon />} 
          color="success" 
          variant={props.this.state.actionSet === 3 ? "contained" : "outlined"}
          fullWidth
          style={getActionButtonStyle(props.this.state.actionSet, 3)}
        >
          Firmware Installieren
        </Button>
      </div>

      {/* Rechter Bereich mit Aktions-Details */}
      <div style={{ 
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column',
        gap: '20px',
        minWidth: 0
      }}>
        {/* Aktions-Bereich */}
        <div style={{
          backgroundColor: document.documentElement.getAttribute('data-theme') === 'dark' ? '#2d2d2d' : '#f8f9fa',
          borderRadius: '8px',
          padding: '20px',
          border: document.documentElement.getAttribute('data-theme') === 'dark' ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #e0e0e0',
          transition: 'all 0.3s ease'
        }}>
        {
          {
              1: (
                <div style={{ textAlign: 'center' }}>
                  <h3 style={{ 
                    margin: '0 0 20px 0', 
                    color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#ffffff' : '#333', 
                    fontSize: '20px', 
                    fontWeight: '600',
                    transition: 'color 0.3s ease'
                  }}>
                    Koffer neustarten
                  </h3>
                  <p style={{ 
                    margin: '0 0 25px 0', 
                    color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#666', 
                    fontSize: '14px',
                    transition: 'color 0.3s ease'
                  }}>
                    Startet den Koffer neu. Alle laufenden Prozesse werden beendet.
                  </p>
                  <Button 
                    onClick={(event) => { props.sendRestart() }} 
                    startIcon={<SendIcon />} 
                    color="info" 
                    variant="contained"
                    size="large"
                    style={{ minWidth: '200px', height: '45px', fontSize: '16px' }}
                  >
                    Neustarten
                  </Button>
              </div>
              ),
              2: (
                <div>
                  <h3 style={{ 
                    margin: '0 0 15px 0', 
                    color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#ffffff' : '#333', 
                    fontSize: '20px', 
                    fontWeight: '600',
                    transition: 'color 0.3s ease'
                  }}>
                    Firmware Übertragen
                  </h3>
                  <Stack direction="row" spacing={2} style={{ marginBottom: '20px' }} alignItems="flex-end">
                  <FormControl fullWidth>
                    <InputLabel id="label-firmware-version">Firmware Version</InputLabel>
                    <Select
                      labelId="label-firmware-version"
                      id="firmware-version-select"
                      value={currentVersion}
                      label="Firmware Version"
                      onChange={(event) => setCurrentVersion(event.target.value)}
                    >
                      {Array.isArray(props.this.state.firmware) && props.this.state.firmware.length > 0 ? (
                        props.this.state.firmware.map(function(firmware){
                          if (!firmware || !firmware.id) return null;
                        return (
                              <MenuItem key={firmware.id} value={firmware.id}>
                                {firmware.name || 'Unbekannt'} - {firmware.version || 'N/A'}
                              </MenuItem>
                          );
                        })
                      ) : (
                        <MenuItem disabled>Keine Firmware verfügbar</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                    <Button 
                      onClick={(event) => { props.sendFirmwareUpdate(currentVersion) }} 
                      startIcon={<SendIcon />} 
                      color="secondary" 
                      variant="contained"
                      disabled={currentVersion === 0}
                      style={{ 
                        minWidth: '150px', 
                        height: '56px',
                        marginTop: '0px'
                      }}
                    >
                      Übertragen
                    </Button>
                </Stack>
                  {props.this.state.firmwareUpdate.progress > 0 && (
                    <div>
                      <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        marginBottom: '8px',
                        fontSize: '13px',
                        color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#666',
                        transition: 'color 0.3s ease'
                      }}>
                        <span>Fortschritt</span>
                        <span>{props.this.state.firmwareUpdate.progress}%</span>
              </div>
                      <LinearProgress 
                        variant="determinate" 
                        value={props.this.state.firmwareUpdate.progress} 
                        style={{
                          height: '10px', 
                          borderRadius: '10px',
                          backgroundColor: document.documentElement.getAttribute('data-theme') === 'dark' ? '#3a3a3a' : '#e0e0e0',
                          transition: 'background-color 0.3s ease'
                        }}
                      />
              </div>
                  )}
              </div>
              ),
              3: (
                <div style={{ textAlign: 'center' }}>
                  <h3 style={{ 
                    margin: '0 0 20px 0', 
                    color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#ffffff' : '#333', 
                    fontSize: '20px', 
                    fontWeight: '600',
                    transition: 'color 0.3s ease'
                  }}>
                    Firmware Installieren
                  </h3>
                  <p style={{ 
                    margin: '0 0 25px 0', 
                    color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#666', 
                    fontSize: '14px',
                    transition: 'color 0.3s ease'
                  }}>
                    Installiert die zuvor übertragene Firmware auf dem Koffer.
                  </p>
                  <Button 
                    onClick={(event) => { props.sendFirmwareWrite() }} 
                    startIcon={<SendIcon />} 
                    color="success" 
                    variant="contained"
                    size="large"
                    style={{ minWidth: '200px', height: '45px', fontSize: '16px' }}
                  >
                    Installieren
                  </Button>
                </div>
              ),
          }[props.this.state.actionSet]
        }
        </div>

        {/* Timeline-Bereich */}
        {(props.this.state.currentActionId || (Array.isArray(props.history) && props.history.length > 0)) && (
          <div style={{
            backgroundColor: document.documentElement.getAttribute('data-theme') === 'dark' ? '#2d2d2d' : '#ffffff',
            borderRadius: '8px',
            padding: '20px',
            border: document.documentElement.getAttribute('data-theme') === 'dark' ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #e0e0e0',
            maxHeight: '300px',
            overflowY: 'auto',
            transition: 'all 0.3s ease'
          }}>
            <h4 style={{ 
              margin: '0 0 15px 0', 
              color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#ffffff' : '#333', 
              fontSize: '16px', 
              fontWeight: '600',
              borderBottom: document.documentElement.getAttribute('data-theme') === 'dark' ? '2px solid rgba(255, 255, 255, 0.1)' : '2px solid #e0e0e0',
              paddingBottom: '10px',
              transition: 'all 0.3s ease'
            }}>
              Aktionsverlauf
            </h4>
            {Array.isArray(props.history) && props.history.length > 0 ? (
              <Timeline style={{ margin: 0, padding: 0 }}>
                {props.history.map(function(update, index) {
                  return (
                    <TimelineItem key={index}>
                      <TimelineOppositeContent 
                        color="text.secondary" 
                        style={{ 
                          flex: '0 0 80px',
                          fontSize: '12px'
                        }}
                      >
                        {moment(new Date(update.time)).format('HH:mm:ss')}
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineDot 
                          color={update.last === 1 ? "success" : "primary"}
                          variant={update.last === 1 ? "filled" : "outlined"}
                        />
                        {update.last === 0 && <TimelineConnector />}
                      </TimelineSeparator>
                      <TimelineContent style={{ paddingTop: '8px' }}>
                        <div style={{ 
                          fontSize: '14px',
                          color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#ffffff' : '#333',
                          fontWeight: update.last === 1 ? '500' : '400',
                          transition: 'color 0.3s ease'
                        }}>
                          {update.text}
                        </div>
                      </TimelineContent>
                    </TimelineItem>
                  )
                })}
              </Timeline>
            ) : (
              <div style={{
                fontSize: '14px',
                color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#666',
                padding: '10px 0'
              }}>
                Aktion gestartet. Warte auf erste Status-Rueckmeldung vom Koffer...
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export function DisplayCardActionHistory(props) {
  const getStatusColor = (success, status) => {
    if (status === 'Erfolgreich' || success === true) {
      return '#4caf50'; // Grün
    } else if (status === 'Fehlgeschlagen' || success === false) {
      return '#f44336'; // Rot
    } else if (status === 'Abgebrochen') {
      return '#9e9e9e'; // Grau (Abgebrochen)
    } else {
      return '#ff9800'; // Orange (In Bearbeitung)
    }
  };

  const getStatusIcon = (success, status) => {
    if (status === 'Erfolgreich' || success === true) {
      return '✓';
    } else if (status === 'Fehlgeschlagen' || success === false) {
      return '✗';
    } else if (status === 'Abgebrochen') {
      return '⊘'; // Abgebrochen-Symbol
    } else {
      return '⟳';
    }
  };

  return (
    <div className="action-history-container" style={{ minHeight: '400px' }}>
      {props.loading ? (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <LinearProgress />
          <div style={{ 
            marginTop: '10px', 
            color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#666',
            transition: 'color 0.3s ease'
          }}>Lade Verlauf...</div>
        </div>
      ) : props.history && props.history.length > 0 ? (
        <div>
          <TableContainer className="action-history-table-container">
            <Table size="medium" style={{ fontSize: '14px' }}>
              <TableHead>
                <TableRow style={{ 
                  background: document.documentElement.getAttribute('data-theme') === 'dark' ? '#2d2d2d' : '#ffffff'
                }}>
                  <TableCell style={{ fontSize: '15px', fontWeight: 'bold', padding: '12px 16px' }}>Zeitpunkt</TableCell>
                  <TableCell style={{ fontSize: '15px', fontWeight: 'bold', padding: '12px 16px' }}>Aktion</TableCell>
                  <TableCell style={{ fontSize: '15px', fontWeight: 'bold', padding: '12px 16px' }}>Status</TableCell>
                  <TableCell style={{ fontSize: '15px', fontWeight: 'bold', padding: '12px 16px' }}>Ausgeführt von</TableCell>
                  <TableCell style={{ fontSize: '15px', fontWeight: 'bold', padding: '12px 16px' }}>Aktionen</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.history.map((item) => (
                  <TableRow key={item.id} style={{ height: 'auto' }} className="action-history-table-row">
                    <TableCell style={{ padding: '14px 16px', fontSize: '14px' }}>
                      {moment(new Date(item.created)).format('DD.MM.YYYY HH:mm:ss')}
                    </TableCell>
                    <TableCell style={{ padding: '14px 16px', fontSize: '14px' }}>
                      <div>
                        <strong style={{ fontSize: '15px' }}>{item.type}</strong>
                        {item.details && (
                          <div style={{ 
                            fontSize: '13px', 
                            color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#666', 
                            marginTop: '4px',
                            transition: 'color 0.3s ease'
                          }}>
                            {item.details}
                          </div>
                        )}
                      </div>
                    </TableCell>
                    <TableCell style={{ padding: '14px 16px', fontSize: '14px' }}>
                      <div style={{ 
                        display: 'inline-flex', 
                        alignItems: 'center', 
                        gap: '6px',
                        color: getStatusColor(item.success, item.status)
                      }}>
                        <span style={{ 
                          fontWeight: 'bold',
                          fontSize: '16px'
                        }}>
                          {getStatusIcon(item.success, item.status)}
                        </span>
                        <span style={{ fontSize: '14px' }}>{item.status}</span>
                      </div>
                    </TableCell>
                    <TableCell style={{ padding: '14px 16px', fontSize: '14px' }}>
                      {item.user}
                    </TableCell>
                    <TableCell style={{ padding: '14px 16px' }}>
                      <Button 
                        size="medium" 
                        variant="outlined"
                        onClick={() => props.onShowDetails(item.id)}
                        style={{ fontSize: '13px' }}
                      >
                        Details
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          
          {/* Pagination */}
          <TablePagination
            component="div"
            count={props.totalCount || (props.history ? props.history.length : 0)}
            page={props.page || 0}
            onPageChange={props.onPageChange || (() => {})}
            rowsPerPage={props.rowsPerPage || 10}
            onRowsPerPageChange={props.onRowsPerPageChange || (() => {})}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            labelRowsPerPage="Zeilen pro Seite:"
            labelDisplayedRows={({ from, to, count, page }) => {
              const rowsPerPage = props.rowsPerPage || 10;
              const totalPages = count > 0 ? Math.ceil(count / rowsPerPage) : 1;
              const currentPage = page + 1;
              return `Seite ${currentPage} von ${totalPages}`;
            }}
            className="table-pagination"
          />
        </div>
      ) : (
        <div style={{ 
          padding: '60px 20px', 
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '200px'
        }}>
          <HistoryIcon sx={{ 
            fontSize: '64px', 
            color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#4a5568' : '#cbd5e1',
            marginBottom: '16px',
            opacity: 0.5
          }} />
          <div style={{ 
            fontSize: '18px',
            fontWeight: 500,
            color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#9ca3af' : '#6b7280',
            marginBottom: '8px',
            transition: 'color 0.3s ease'
          }}>
            Keine Aktionen vorhanden
          </div>
          <div style={{ 
            fontSize: '14px',
            color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#6b7280' : '#9ca3af',
            transition: 'color 0.3s ease'
          }}>
            Es wurden noch keine Aktionen ausgeführt
          </div>
        </div>
      )}
    </div>
  );
}

export function DisplayActionDetails(props) {
  const getStepText = (content) => {
    // Mappe Status-Codes zu benutzerfreundlichen Texten
    const stepTexts = {
      // Restart-Actions (3000er Bereich)
      3001: 'Anfrage',
      3002: 'Empfangen',
      3003: 'Neugestartet',
      3004: 'Fehler',
      // Firmware-Download-Actions (1000er Bereich)
      1001: 'Anfrage',
      1002: 'Empfangen',
      1003: 'Lädt herunter',
      1004: 'Abgeschlossen',
      1005: 'Fehler',
      1006: 'CRC Korrekt',
      1007: 'CRC Fehler',
      // Firmware-Write-Actions (2000er Bereich)
      2001: 'Anfrage',
      2002: 'Empfangen',
      2003: 'Läuft',
      2004: 'Abgeschlossen',
      2005: 'Fehler',
      2006: 'CRC Korrekt',
      2007: 'CRC Fehler'
    };
    return stepTexts[content] || `Status ${content}`;
  };

  const getStepTooltip = (content) => {
    // Detaillierte Erklärungen für jeden Status-Code
    const tooltips = {
      // Restart-Actions (3000er Bereich)
      3001: 'Neustart-Anfrage wurde vom Server an den Koffer gesendet',
      3002: 'Der Koffer hat die Neustart-Anfrage empfangen und bestätigt',
      3003: 'Der Koffer wurde erfolgreich neugestartet',
      3004: 'Beim Neustart des Panels ist ein Fehler aufgetreten',
      // Firmware-Download-Actions (1000er Bereich)
      1001: 'Firmware-Download-Anfrage wurde vom Server an den Koffer gesendet',
      1002: 'Der Koffer hat die Download-Anfrage empfangen und bestätigt',
      1003: 'Die Firmware wird derzeit vom Koffer heruntergeladen',
      1004: 'Der Firmware-Download wurde erfolgreich abgeschlossen',
      1005: 'Beim Firmware-Download ist ein Fehler aufgetreten',
      1006: 'Die CRC-Prüfung der heruntergeladenen Firmware war erfolgreich',
      1007: 'Die CRC-Prüfung der heruntergeladenen Firmware ist fehlgeschlagen',
      // Firmware-Write-Actions (2000er Bereich)
      2001: 'Firmware-Installations-Anfrage wurde vom Server an den Koffer gesendet',
      2002: 'Der Koffer hat die Installations-Anfrage empfangen und bestätigt',
      2003: 'Die Firmware wird derzeit auf dem Koffer installiert',
      2004: 'Die Firmware-Installation wurde erfolgreich abgeschlossen',
      2005: 'Bei der Firmware-Installation ist ein Fehler aufgetreten',
      2006: 'Die CRC-Prüfung der installierten Firmware war erfolgreich',
      2007: 'Die CRC-Prüfung der installierten Firmware ist fehlgeschlagen'
    };
    return tooltips[content] || `Status-Code: ${content}`;
  };

  const getStepColor = (content) => {
    // Erfolgreiche finale Status-Codes
    // 3003: Koffer neugestartet
    // 1004: Firmware-Download abgeschlossen
    // 1006: Firmware-Download CRC Korrekt
    // 2004: Firmware-Write abgeschlossen (written) - Finaler Schritt bei Firmware-Installation
    // Hinweis: 2006 ist kein finaler Schritt, da 2004 der finale Schritt ist
    if ([3003, 1004, 1006, 2004].includes(content)) {
      return '#4caf50'; // Grün
    }
    // Fehler-Status-Codes
    // 3004: Koffer neustart fehler
    // 1005: Firmware-Download Fehler
    // 1007: Firmware-Download CRC Fehler
    // 2005: Firmware-Write Fehler
    // 2007: Firmware-Write CRC Fehler
    if ([3004, 1005, 1007, 2005, 2007].includes(content)) {
      return '#f44336'; // Rot
    }
    // Zwischenschritte
    // 3001, 3002: Restart Zwischenschritte
    // 1001, 1002, 1003: Firmware-Download Zwischenschritte
    // 2001, 2002, 2003: Firmware-Write Zwischenschritte
    return '#2196f3'; // Blau
  };

  const details = props.details;
  const actionType = details.value === 1 ? 'Firmware Download' : 
                     details.value === 2 ? 'Firmware Installation' : 
                     details.value === 3 ? 'Neustart' : 'Unbekannt';

  const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';
  const textColor = isDarkMode ? '#ffffff' : '#1a1a1a';
  const secondaryTextColor = isDarkMode ? '#d1d5db' : '#666';

  return (
    <div style={{ padding: '10px 0', color: textColor, transition: 'color 0.3s ease' }}>
      <div style={{ marginBottom: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
          <div>
            <strong style={{ color: textColor }}>Aktion:</strong> <span style={{ color: textColor }}>{actionType}</span>
          </div>
          <div>
            <strong style={{ color: textColor }}>Zeitpunkt:</strong> <span style={{ color: textColor }}>{moment(new Date(details.created)).format('DD.MM.YYYY HH:mm:ss')}</span>
          </div>
        </div>
        <div style={{ marginTop: '10px' }}>
          <strong style={{ color: textColor }}>Ausgeführt von:</strong> <span style={{ color: textColor }}>{details.user ? (details.user.username || details.user.email) : 'System'}</span>
        </div>
        {/* Bei Firmware-Installation: Alte und neue Version anzeigen */}
        {actionType === 'Firmware Installation' && details.a ? (
          <div style={{ marginTop: '10px' }}>
            <strong style={{ color: textColor }}>Versionen:</strong>
            <div style={{ marginTop: '6px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
              {props.panelVersion && (
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '6px',
                  padding: '4px 8px',
                  backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                  borderRadius: '4px'
                }}>
                  <span style={{ 
                    fontSize: '0.85em', 
                    color: secondaryTextColor 
                  }}>
                    Alt:
                  </span>
                  <span style={{ 
                    color: textColor,
                    fontFamily: 'monospace',
                    fontWeight: '500'
                  }}>
                    {props.panelVersion}
                  </span>
                </div>
              )}
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '6px',
                padding: '4px 8px',
                backgroundColor: isDarkMode ? 'rgba(76, 175, 80, 0.15)' : 'rgba(76, 175, 80, 0.1)',
                borderRadius: '4px'
              }}>
                <span style={{ 
                  fontSize: '0.85em', 
                  color: secondaryTextColor 
                }}>
                  Neu:
                </span>
                <span style={{ 
                  color: textColor,
                  fontFamily: 'monospace',
                  fontWeight: '600'
                }}>
                  {details.a}
                </span>
              </div>
            </div>
          </div>
        ) : details.a && (
          <div style={{ marginTop: '10px' }}>
            <strong style={{ color: textColor }}>Version:</strong> <span style={{ color: textColor }}>{details.a}</span>
          </div>
        )}
        {details.c && (
          <div style={{ marginTop: '10px' }}>
            <strong style={{ color: textColor }}>Koffer-ID:</strong> <span style={{ color: textColor }}>{details.c}</span>
          </div>
        )}
      </div>

      <Divider style={{ margin: '20px 0', borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.12)' }} />

      <div>
        <strong style={{ fontSize: '16px', marginBottom: '15px', display: 'block', color: textColor }}>Verlauf:</strong>
        {details.steps && details.steps.length > 0 ? (
          <Timeline>
            {details.steps.map((step, index) => (
              <TimelineItem key={step.id}>
                <TimelineOppositeContent color="text.secondary" style={{ flex: '0 0 150px' }}>
                  {moment(new Date(step.created)).format('HH:mm:ss')}
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot style={{ backgroundColor: getStepColor(step.content) }} />
                  {index < details.steps.length - 1 && <TimelineConnector />}
                </TimelineSeparator>
                <TimelineContent>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <MuiTooltip title={getStepTooltip(step.content)} arrow placement="top">
                      <span style={{ 
                        color: getStepColor(step.content),
                        fontWeight: '500',
                        cursor: 'help',
                        textDecoration: 'underline',
                        textDecorationStyle: 'dotted',
                        textUnderlineOffset: '3px'
                      }}>
                        {getStepText(step.content)}
                      </span>
                    </MuiTooltip>
                    <span style={{ 
                      fontSize: '0.85em', 
                      color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#666',
                      fontStyle: 'italic',
                      transition: 'color 0.3s ease'
                    }}>
                      ({step.who === 1 ? 'Benutzer' : 'System'})
                    </span>
                  </div>
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
        ) : (
          <div style={{ 
            textAlign: 'center', 
            color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#9ca3af' : '#6b7280',
            transition: 'color 0.3s ease',
            fontSize: '16px',
            fontWeight: 500,
            padding: '40px 20px'
          }}>
            Keine Schritte vorhanden
        </div>
        )}
      </div>
    </div>
  );
}

export function DisplayCardDeviceLogs(props) {
  const [detailLog, setDetailLog] = useState(null);
  const logs = useMemo(() => props.logs || [], [props.logs]);
  const isHealthCheck = (log) => Number(log?.messageCode) === 8;

  useEffect(() => {
    if (!detailLog) return;
    const fresh = logs.find((log) => log.id === detailLog.id);
    if (!fresh) return;
    if (fresh.confirmed !== detailLog.confirmed || fresh.confirmedBy !== detailLog.confirmedBy) {
      setDetailLog(fresh);
    }
  }, [logs, detailLog]);
  let filteredLogs;
  if (props.hideHealthChecks) {
    filteredLogs = [...logs].sort((a, b) => {
      if (isHealthCheck(a)) return -1;
      if (isHealthCheck(b)) return 1;
      return new Date(b.created) - new Date(a.created);
    });
  } else {
    filteredLogs = logs;
  }

  // Hilfsfunktion zur Formatierung der Uptime
  const formatUptime = (ms) => {
    const seconds = Math.floor(ms / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    
    if (days > 0) return `${days}d ${hours % 24}h`;
    if (hours > 0) return `${hours}h ${minutes % 60}m`;
    if (minutes > 0) return `${minutes}m ${seconds % 60}s`;
    return `${seconds}s`;
  };

  // Hilfsfunktion zur Formatierung des Speichers
  const formatMemory = (bytes) => {
    if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    if (bytes >= 1024) return `${(bytes / 1024).toFixed(2)} KB`;
    return `${bytes} B`;
  };

  // resetCause: verständliche Beschreibung des Neustart-Grundes
  const getResetCauseLabel = (value) => {
    const labels = {
      WDT: 'Programm hing oder war blockiert',
      BOR: 'Spannung war zu niedrig',
      EXT: 'Externer Reset (z. B. Reset-Taste)',
      POR: 'Gerät wurde eingeschaltet',
      UNK: 'Unbekannt'
    };
    return value ? (labels[value] || value) : value;
  };

  // Empfangsqualität: −1 = unbekannt, 0–31 mit Hinweis (schlecht/ok/gut)
  const formatSignalQuality = (csq) => {
    if (csq === undefined || csq === null) return '–';
    if (csq === -1) return 'unbekannt';
    if (csq < 0 || csq > 31) return `${csq}`;
    const hint = csq < 10 ? ' (schlecht)' : csq <= 20 ? ' (ok)' : ' (gut)';
    return `${csq}${hint}`;
  };

  // Hilfsfunktion zur Bestimmung des Icons für jeden Log-Typ
  const getLogIcon = (messageCode) => {
    const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';
    const iconColor = isDarkMode ? '#d1d5db' : '#666';
    const errorColor = '#f44336';
    
    switch (messageCode) {
      case 1: // Display Fehler
        return <MonitorIcon style={{ fontSize: '20px', color: errorColor }} />;
      case 2: // Download Error
        return <CloudDownloadIcon style={{ fontSize: '20px', color: errorColor }} />;
      case 3: // CRC Download error
        return <CloudDownloadIcon style={{ fontSize: '20px', color: errorColor }} />;
      case 4: // Firmware install error
        return <SystemUpdateAltIcon style={{ fontSize: '20px', color: errorColor }} />;
      case 5: // Firmware arc error
        return <SystemUpdateAltIcon style={{ fontSize: '20px', color: errorColor }} />;
      case 6: // SD Error
        return <SdCardIcon style={{ fontSize: '20px', color: errorColor }} />;
      case 7: // BME error
        return <ThermostatIcon style={{ fontSize: '20px', color: errorColor }} />;
      case 8: // Health-Check
        return <HealthAndSafetyIcon style={{ fontSize: '20px', color: '#4caf50' }} />;
      case 1107: // Feueralarm
        return <LocalFireDepartmentIcon style={{ fontSize: '20px', color: errorColor }} />;
      default:
        return <WarningIcon style={{ fontSize: '20px', color: iconColor }} />;
    }
  };

  // Hilfsfunktion: Einzelnen Health-Check-Eintrag rendern
  const HealthItem = ({ icon: Icon, label, value, iconClass = 'neutral', valueClass = '' }) => (
    <div className="healthcheck-item">
      <div className={`healthcheck-item-icon ${iconClass}`}>
        <Icon style={{ fontSize: '18px' }} />
      </div>
      <div className="healthcheck-item-content">
        <span className="healthcheck-item-label">{label}</span>
        <span className={`healthcheck-item-value ${valueClass}`}>{value}</span>
      </div>
    </div>
  );

  // Hilfsfunktion: Status-Badge (OK/Fehler)
  const StatusBadge = ({ ok, okLabel = 'OK', failLabel = 'Fehler' }) => (
    <span className={`healthcheck-status-badge ${ok ? 'ok' : 'fail'}`}>
      {ok ? <CheckCircleOutlineIcon style={{ fontSize: '14px' }} /> : <ErrorIcon style={{ fontSize: '14px' }} />}
      {ok ? okLabel : failLabel}
    </span>
  );

  // Rendert Health-Check Details als übersichtliche Status-Box
  const renderHealthCheckData = (log) => {
    if (!log.log || !log.log.data || Number(log.messageCode) !== 8) return null;

    const data = log.log.data;
    const d = data;

    return (
      <div className="healthcheck-box">
        <div className="healthcheck-box-header">
          <HealthAndSafetyIcon style={{ fontSize: '22px' }} />
          <span>Health-Check Status</span>
        </div>
        <div className="healthcheck-box-body">
          {/* System */}
          <div className="healthcheck-section">
            <div className="healthcheck-section-title">System</div>
            <div className="healthcheck-grid">
              {d.uptime !== undefined && (
                <HealthItem icon={TimerIcon} label="Laufzeit" value={formatUptime(d.uptime)} />
              )}
              {d.freeMem !== undefined && (
                <HealthItem icon={MemoryIcon} label="Freier Speicher" value={formatMemory(d.freeMem)} />
              )}
              {d.resetCause && (
                <HealthItem icon={RefreshIcon} label="Neustart-Grund" value={getResetCauseLabel(d.resetCause)} />
              )}
              {d.wdtCount !== undefined && (
                <HealthItem icon={RestartAltIcon} label="System-Checks seit Start" value={String(d.wdtCount)} />
              )}
            </div>
          </div>

          {/* Verbindung & Komponenten */}
          <div className="healthcheck-section">
            <div className="healthcheck-section-title">Verbindung & Komponenten</div>
            <div className="healthcheck-grid">
              {d.sdOK !== undefined && (
                <div className="healthcheck-item">
                  <div className={`healthcheck-item-icon ${d.sdOK ? 'success' : 'error'}`}>
                    <StorageIcon style={{ fontSize: '18px' }} />
                  </div>
                  <div className="healthcheck-item-content">
                    <span className="healthcheck-item-label">Speicherkarte</span>
                    <span className="healthcheck-item-value"><StatusBadge ok={d.sdOK} /></span>
                  </div>
                </div>
              )}
              {d.bmeOK !== undefined && (
                <div className="healthcheck-item">
                  <div className={`healthcheck-item-icon ${d.bmeOK ? 'success' : 'error'}`}>
                    <ThermostatIcon style={{ fontSize: '18px' }} />
                  </div>
                  <div className="healthcheck-item-content">
                    <span className="healthcheck-item-label">Umgebungssensor</span>
                    <span className="healthcheck-item-value"><StatusBadge ok={d.bmeOK} /></span>
                  </div>
                </div>
              )}
              {d.gsmReady !== undefined && (
                <div className="healthcheck-item">
                  <div className={`healthcheck-item-icon ${d.gsmReady ? 'success' : 'error'}`}>
                    <PhoneAndroidIcon style={{ fontSize: '18px' }} />
                  </div>
                  <div className="healthcheck-item-content">
                    <span className="healthcheck-item-label">Modem bereit</span>
                    <span className="healthcheck-item-value"><StatusBadge ok={d.gsmReady} okLabel="Ja" failLabel="Nein" /></span>
                  </div>
                </div>
              )}
              {d.gsmNetwork !== undefined && (
                <div className="healthcheck-item">
                  <div className={`healthcheck-item-icon ${d.gsmNetwork ? 'success' : 'error'}`}>
                    <NetworkCheckIcon style={{ fontSize: '18px' }} />
                  </div>
                  <div className="healthcheck-item-content">
                    <span className="healthcheck-item-label">Im Mobilfunknetz</span>
                    <span className="healthcheck-item-value"><StatusBadge ok={d.gsmNetwork} okLabel="Ja" failLabel="Nein" /></span>
                  </div>
                </div>
              )}
              {d.gsmGprs !== undefined && (
                <div className="healthcheck-item">
                  <div className={`healthcheck-item-icon ${d.gsmGprs ? 'success' : 'error'}`}>
                    <NetworkCheckIcon style={{ fontSize: '18px' }} />
                  </div>
                  <div className="healthcheck-item-content">
                    <span className="healthcheck-item-label">Datenverbindung</span>
                    <span className="healthcheck-item-value"><StatusBadge ok={d.gsmGprs} okLabel="Verbunden" failLabel="Nicht verbunden" /></span>
                  </div>
                </div>
              )}
              {d.mqttConnected !== undefined && (
                <div className="healthcheck-item">
                  <div className={`healthcheck-item-icon ${d.mqttConnected ? 'success' : 'error'}`}>
                    <CloudQueueIcon style={{ fontSize: '18px' }} />
                  </div>
                  <div className="healthcheck-item-content">
                    <span className="healthcheck-item-label">Mit Server verbunden</span>
                    <span className="healthcheck-item-value"><StatusBadge ok={d.mqttConnected} okLabel="Ja" failLabel="Nein" /></span>
                  </div>
                </div>
              )}
              {d.ipAddress !== undefined && d.ipAddress !== null && (
                <HealthItem icon={RouterIcon} label="Lokale IP-Adresse" value={String(d.ipAddress)} />
              )}
              {d.signalQuality !== undefined && (
                <HealthItem icon={SignalCellularAltIcon} label="Empfangsqualität" value={formatSignalQuality(d.signalQuality)} />
              )}
              {d.lastConnSuccess !== undefined && (
                <HealthItem icon={LinkIcon} label="Zeit seit letztem Connect" value={formatUptime(d.lastConnSuccess)} iconClass="success" />
              )}
            </div>
          </div>

          {/* Fehler & Zähler */}
          <div className="healthcheck-section">
            <div className="healthcheck-section-title">Fehler & Zähler</div>
            <div className="healthcheck-grid">
              {d.gsmFailures !== undefined && (
                <HealthItem
                  icon={PhoneAndroidIcon}
                  label="Modem-Fehler"
                  value={String(d.gsmFailures)}
                  iconClass={d.gsmFailures > 0 ? 'error' : 'neutral'}
                  valueClass={d.gsmFailures > 0 ? 'error' : ''}
                />
              )}
              {d.mqttFailures !== undefined && (
                <HealthItem
                  icon={CloudQueueIcon}
                  label="Server-Verbindungsfehler"
                  value={String(d.mqttFailures)}
                  iconClass={d.mqttFailures > 0 ? 'error' : 'neutral'}
                  valueClass={d.mqttFailures > 0 ? 'error' : ''}
                />
              )}
              {d.retryCount !== undefined && (
                <HealthItem
                  icon={ReplayIcon}
                  label="Reconnect-Versuch"
                  value={String(d.retryCount)}
                  iconClass={d.retryCount > 0 ? 'error' : 'neutral'}
                  valueClass={d.retryCount > 0 ? 'error' : ''}
                />
              )}
            </div>
          </div>

          {/* Umgebung (BME) */}
          <div className="healthcheck-section">
            <div className="healthcheck-section-title">Umgebung</div>
            <div className="healthcheck-grid">
              {d.temperature !== undefined && d.temperature !== null && (
                <HealthItem
                  icon={ThermostatIcon}
                  label="Temperatur"
                  value={typeof d.temperature === 'number' ? `${d.temperature.toFixed(1)} °C` : d.temperature}
                />
              )}
              {d.pressure !== undefined && d.pressure !== null && (
                <HealthItem
                  icon={CompressIcon}
                  label="Luftdruck"
                  value={typeof d.pressure === 'number' ? `${d.pressure.toFixed(1)} hPa` : d.pressure}
                />
              )}
              {d.humidity !== undefined && d.humidity !== null && (
                <HealthItem
                  icon={WaterDropIcon}
                  label="Luftfeuchtigkeit"
                  value={typeof d.humidity === 'number' ? `${d.humidity.toFixed(1)} %` : d.humidity}
                />
              )}
              {d.gas !== undefined && d.gas !== null && (
                <HealthItem
                  icon={LocalGasStationIcon}
                  label="Gas-Widerstand"
                  value={typeof d.gas === 'number' ? `${d.gas.toFixed(1)} kΩ` : d.gas}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const getLogData = (log) => log?.log?.data || log?.data || null;

  const formatLogValue = (value) => {
    if (value === null || value === undefined || value === '') return '–';
    if (typeof value === 'boolean') return value ? 'Ja' : 'Nein';
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
  };

  const FIELD_LABELS = {
    uptime: 'Laufzeit',
    freeMem: 'Freier Speicher',
    resetCause: 'Neustart-Grund',
    wdtCount: 'System-Checks seit Start',
    sdOK: 'Speicherkarte',
    bmeOK: 'Umgebungssensor',
    gsmReady: 'Modem bereit',
    gsmNetwork: 'Im Mobilfunknetz',
    gsmGprs: 'Datenverbindung',
    mqttConnected: 'Mit Server verbunden',
    ipAddress: 'Lokale IP-Adresse',
    signalQuality: 'Empfangsqualität',
    lastConnSuccess: 'Zeit seit letztem Connect',
    gsmFailures: 'Modem-Fehler',
    mqttFailures: 'Server-Verbindungsfehler',
    retryCount: 'Reconnect-Versuch',
    temperature: 'Temperatur',
    pressure: 'Luftdruck',
    humidity: 'Luftfeuchtigkeit',
    gas: 'Gas-Widerstand',
    A: 'Anschluss 1',
    B: 'Anschluss 2',
    C: 'Anschluss 3',
    D: 'Anschluss 4',
    a: 'Anschluss 1',
    b: 'Anschluss 2',
    c: 'Anschluss 3',
    d: 'Anschluss 4',
    t: 'Temperatur',
    h: 'Luftfeuchtigkeit',
    o: 'Anschluss 1 Spannung',
    j: 'Anschluss 2 Spannung',
    e: 'Anschluss 3 Spannung',
    p: 'Anschluss 4 Spannung',
    s: 'GSM-Signal',
    r: 'Laufzeit',
  };

  const renderGenericData = (data) => {
    if (!data || typeof data !== 'object') return null;
    const entries = Object.entries(data).filter(([, value]) => value !== null && value !== undefined && value !== '');
    if (entries.length === 0) return null;
    return (
      <div className="log-detail-grid">
        {entries.map(([key, value]) => (
          <div key={key} className="log-detail-item">
            <span className="log-detail-label">{FIELD_LABELS[key] || key}</span>
            <span className="log-detail-value">{formatLogValue(value)}</span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="panel-logs-container">
      {props.loading ? (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <LinearProgress />
          <div style={{ 
            marginTop: '10px', 
            color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#666',
            transition: 'color 0.3s ease'
          }}>Lade Logs...</div>
        </div>
      ) : filteredLogs && filteredLogs.length > 0 ? (
        <div>
          <TableContainer className="panel-logs-table-container">
            <Table size="medium" style={{ fontSize: '14px' }}>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontSize: '15px', fontWeight: 'bold', padding: '12px 16px' }}>Zeitpunkt</TableCell>
                  <TableCell style={{ fontSize: '15px', fontWeight: 'bold', padding: '12px 16px' }}>Nachricht</TableCell>
                  <TableCell style={{ fontSize: '15px', fontWeight: 'bold', padding: '12px 16px' }}>Wichtigkeit</TableCell>
                  <TableCell style={{ fontSize: '15px', fontWeight: 'bold', padding: '12px 16px' }}>Status</TableCell>
                  <TableCell style={{ fontSize: '15px', fontWeight: 'bold', padding: '12px 16px' }}>Aktion</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredLogs.map((log) => (
                <TableRow
                  key={log.id}
                  className="panel-logs-table-row is-clickable"
                  onClick={() => setDetailLog(log)}
                >
                  <TableCell style={{ padding: '14px 16px', fontSize: '14px' }}>
                    {moment(new Date(log.created)).format('DD.MM.YYYY HH:mm:ss')}
                  </TableCell>
                  <TableCell style={{ padding: '14px 16px', fontSize: '14px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {getLogIcon(log.messageCode)}
                      <strong>{log.message}</strong>
                    </div>
                  </TableCell>
                  <TableCell style={{ padding: '14px 16px' }}>
                    <Chip 
                      label={log.importanceText}
                      size="small"
                      style={{ 
                        backgroundColor: log.importanceColor,
                        color: 'white',
                        fontWeight: 'bold'
                      }}
                    />
                  </TableCell>
                  <TableCell style={{ padding: '14px 16px', fontSize: '14px' }}>
                    {log.confirmed ? (
                      <div>
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: '5px', 
                          color: '#4caf50',
                        }}>
                          <CheckCircleIcon style={{ fontSize: '18px' }} />
                          <span>Bestätigt</span>
                        </div>
                        {log.confirmedBy && (log.confirmedBy.username || log.confirmedBy.email) && (
                          <div style={{ 
                            fontSize: '12px', 
                            color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#666', 
                            marginTop: '4px', 
                            fontStyle: 'italic',
                          }}>
                            von {log.confirmedBy.username || log.confirmedBy.email}
                          </div>
                        )}
                      </div>
                    ) : (
                      <span style={{ 
                        color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#666',
                      }}>Nicht bestätigt</span>
                    )}
                  </TableCell>
                  <TableCell style={{ padding: '14px 16px' }}>
                    {!log.confirmed && log.importance >= 1 && log.confirmable !== false ? (
                      <Button 
                        size="small" 
                        variant="contained"
                        color="primary"
                        disabled={props.confirmingId === log.id}
                        onClick={(event) => {
                          event.stopPropagation();
                          props.onConfirm(log.id);
                        }}
                        style={{ fontSize: '13px' }}
                      >
                        Bestätigen
                      </Button>
                    ) : !log.confirmed && log.importance >= 1 ? (
                      <span className="fc-chip is-alarm">Alarm aktiv</span>
                    ) : (
                      <Icon name="chevron" size={20} sx={{ color: 'text.disabled' }} />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        
        <TablePagination
          component="div"
          count={props.totalCount || (props.logs ? props.logs.length : 0)}
          page={props.page || 0}
          onPageChange={props.onPageChange || (() => {})}
          rowsPerPage={props.rowsPerPage || 10}
          onRowsPerPageChange={props.onRowsPerPageChange || (() => {})}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          labelRowsPerPage="Zeilen pro Seite:"
          labelDisplayedRows={({ from, to, count, page }) => {
            const rowsPerPage = props.rowsPerPage || 10;
            const totalPages = count > 0 ? Math.ceil(count / rowsPerPage) : 1;
            const currentPage = page + 1;
            return `Seite ${currentPage} von ${totalPages}`;
          }}
          className="table-pagination"
        />
        </div>
      ) : (
        <div style={{ 
          padding: '60px 20px', 
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '200px'
        }}>
          <DescriptionIcon sx={{ 
            fontSize: '64px', 
            color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#4a5568' : '#cbd5e1',
            marginBottom: '16px',
            opacity: 0.5
          }} />
          <div style={{ 
            fontSize: '18px',
            fontWeight: 500,
            color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#9ca3af' : '#6b7280',
            marginBottom: '8px',
          }}>
            Keine Logs vorhanden
          </div>
          <div style={{ 
            fontSize: '14px',
            color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#6b7280' : '#9ca3af',
          }}>
            Es wurden noch keine Log-Einträge erstellt
          </div>
        </div>
      )}

      <Dialog
        open={!!detailLog}
        onClose={() => setDetailLog(null)}
        maxWidth="md"
        fullWidth
      >
        {detailLog && (
          <>
            <DialogTitle>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                {getLogIcon(detailLog.messageCode)}
                <span>{detailLog.message}</span>
              </div>
            </DialogTitle>
            <DialogContent>
              <div className="log-detail-meta">
                <div className="log-detail-item">
                  <span className="log-detail-label">Zeitpunkt</span>
                  <span className="log-detail-value">{moment(new Date(detailLog.created)).format('DD.MM.YYYY HH:mm:ss')}</span>
                </div>
                <div className="log-detail-item">
                  <span className="log-detail-label">Wichtigkeit</span>
                  <span className="log-detail-value">
                    <Chip
                      label={detailLog.importanceText}
                      size="small"
                      style={{ backgroundColor: detailLog.importanceColor, color: 'white', fontWeight: 600 }}
                    />
                  </span>
                </div>
                <div className="log-detail-item">
                  <span className="log-detail-label">Status</span>
                  <span className="log-detail-value">
                    {detailLog.confirmed ? 'Bestätigt' : 'Nicht bestätigt'}
                    {detailLog.confirmed && detailLog.confirmedBy && (detailLog.confirmedBy.username || detailLog.confirmedBy.email)
                      ? ` von ${detailLog.confirmedBy.username || detailLog.confirmedBy.email}`
                      : ''}
                  </span>
                </div>
                <div className="log-detail-item">
                  <span className="log-detail-label">Code</span>
                  <span className="log-detail-value">{detailLog.messageCode}</span>
                </div>
              </div>
              {Number(detailLog.messageCode) === 8
                ? renderHealthCheckData(detailLog)
                : renderGenericData(getLogData(detailLog))}
            </DialogContent>
            <DialogActions>
              {!detailLog.confirmed && detailLog.importance >= 1 && detailLog.confirmable !== false && (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={props.confirmingId === detailLog.id}
                  onClick={() => props.onConfirm(detailLog.id)}
                >
                  Bestätigen
                </Button>
              )}
              <Button onClick={() => setDetailLog(null)}>Schliessen</Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </div>
  );
}

export const DisplayCardChartsHumidity = memo(function DisplayCardChartsHumidity(props) {
  const isDailyView = props.viewMode === 'daily';
  
  if (!props.chartdat || !Array.isArray(props.chartdat) || props.chartdat.length === 0) {
    return (
      <div style={{ 
        height: '360px', 
        width: '100%', 
        position: 'relative', 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center',
        textAlign: 'center'
      }}>
        <WaterDropIcon sx={{ 
          fontSize: '64px', 
          color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#4a5568' : '#cbd5e1',
          marginBottom: '16px',
          opacity: 0.5
        }} />
        <div style={{ 
          fontSize: '18px',
          fontWeight: 500,
          color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#9ca3af' : '#6b7280',
          marginBottom: '8px',
          transition: 'color 0.3s ease'
        }}>
          Keine Daten verfügbar
        </div>
        <div style={{ 
          fontSize: '14px',
          color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#6b7280' : '#9ca3af',
          transition: 'color 0.3s ease'
        }}>
          Es wurden noch keine Feuchtigkeitsdaten erfasst
        </div>
      </div>
    );
  }
  
  return (
    <div style={{ height: '360px', width: '100%', animation: 'fadeIn 0.4s ease-in' }}>
      <ResponsiveContainer width="100%" height={360}>
          <LineChart
          width={600} 
          height={280} 
          data={props.chartdat}
            margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
          >
            <CartesianGrid 
              stroke={document.documentElement.getAttribute('data-theme') === 'dark' ? '#4a4a4a' : '#e5e7eb'} 
              strokeDasharray="3 3" 
              opacity={document.documentElement.getAttribute('data-theme') === 'dark' ? 0.3 : 0.5} 
            />

            <XAxis 
              minTickGap={isDailyView ? 30 : 50} 
              padding={{ left: 30, right: 30 }} 
              dataKey="date" 
              label="" 
              angle={isDailyView ? -45 : 0}
              textAnchor={isDailyView ? 'end' : 'middle'}
              height={isDailyView ? 60 : 40}
              tick={{ fill: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#1a1a1a' }}
            />
            <YAxis 
              type="number" 
              unit="%"
              tick={{ fill: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#1a1a1a' }}
            >
              <Label value="" domain={['auto', 'auto']} position="insideLeft" />
            </YAxis>

            <Tooltip content={<CustomTooltipChartHumidity viewMode={props.viewMode} />} />

            <Line 
              type="monotone" 
              dataKey="data" 
              stroke="#6366f1"
              strokeWidth={2.5}
              dot={{ r: isDailyView ? 4 : 3, fill: '#6366f1', strokeWidth: 2, stroke: '#ffffff' }}
              activeDot={{ r: 7, fill: '#4f46e5', strokeWidth: 2, stroke: '#ffffff' }}
            />
            {isDailyView && props.chartdat && props.chartdat.length > 0 && (
              <>
                <Line 
                  type="monotone" 
                  dataKey="min" 
                  stroke="#10b981"
                  strokeWidth={2}
                  strokeDasharray="4 4"
                  dot={false}
                  name="Minimum"
                  opacity={0.7}
                />
                <Line 
                  type="monotone" 
                  dataKey="max" 
                  stroke="#f59e0b"
                  strokeWidth={2}
                  strokeDasharray="4 4"
                  dot={false}
                  name="Maximum"
                  opacity={0.7}
                />
              </>
            )}
          </LineChart>
        </ResponsiveContainer>
    </div>
  );
});

export const DisplayCardChartsTemperature = memo(function DisplayCardChartsTemperature(props) {
  const isDailyView = props.viewMode === 'daily';

  if (!props.chartdat || !Array.isArray(props.chartdat) || props.chartdat.length === 0) {
  return (
      <div style={{ 
        height: '360px', 
        width: '100%', 
        position: 'relative', 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center',
        textAlign: 'center'
      }}>
        <ThermostatIcon sx={{ 
          fontSize: '64px', 
          color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#4a5568' : '#cbd5e1',
          marginBottom: '16px',
          opacity: 0.5
        }} />
        <div style={{ 
          fontSize: '18px',
          fontWeight: 500,
          color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#9ca3af' : '#6b7280',
          marginBottom: '8px',
          transition: 'color 0.3s ease'
        }}>
          Keine Daten verfügbar
        </div>
        <div style={{ 
          fontSize: '14px',
          color: document.documentElement.getAttribute('data-theme') === 'dark' ? '#6b7280' : '#9ca3af',
          transition: 'color 0.3s ease'
        }}>
          Es wurden noch keine Temperaturdaten erfasst
        </div>
      </div>
    );
  }
  
  return (
    <div style={{ height: '360px', width: '100%', animation: 'fadeIn 0.4s ease-in' }}>
      <ResponsiveContainer width="100%" height={360}>
          <LineChart
          width={600} 
          height={280} 
          data={props.chartdat}
            margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
          >
            <CartesianGrid 
              stroke={document.documentElement.getAttribute('data-theme') === 'dark' ? '#4a4a4a' : '#e5e7eb'} 
              strokeDasharray="3 3" 
              opacity={document.documentElement.getAttribute('data-theme') === 'dark' ? 0.3 : 0.5} 
            />

            <XAxis 
              minTickGap={isDailyView ? 30 : 50} 
              padding={{ left: 30, right: 30 }} 
              dataKey="date" 
              label="" 
              angle={isDailyView ? -45 : 0}
              textAnchor={isDailyView ? 'end' : 'middle'}
              height={isDailyView ? 60 : 40}
              tick={{ fill: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#1a1a1a' }}
            />
            <YAxis 
              type="number" 
              unit="°C"
              tick={{ fill: document.documentElement.getAttribute('data-theme') === 'dark' ? '#d1d5db' : '#1a1a1a' }}
            >
              <Label value="" domain={['auto', 'auto']} position="insideLeft" />
            </YAxis>

            <Tooltip content={<CustomTooltipChartTemperature viewMode={props.viewMode} />} />

            <Line 
              type="monotone" 
              dataKey="data" 
              stroke="#6366f1"
              strokeWidth={2.5}
              dot={{ r: isDailyView ? 4 : 3, fill: '#6366f1', strokeWidth: 2, stroke: '#ffffff' }}
              activeDot={{ r: 7, fill: '#4f46e5', strokeWidth: 2, stroke: '#ffffff' }}
            />
            {isDailyView && props.chartdat && props.chartdat.length > 0 && (
              <>
                <Line 
                  type="monotone" 
                  dataKey="min" 
                  stroke="#10b981"
                  strokeWidth={2}
                  strokeDasharray="4 4"
                  dot={false}
                  name="Minimum"
                  opacity={0.7}
                />
                <Line 
                  type="monotone" 
                  dataKey="max" 
                  stroke="#f59e0b"
                  strokeWidth={2}
                  strokeDasharray="4 4"
                  dot={false}
                  name="Maximum"
                  opacity={0.7}
                />
              </>
            )}
          </LineChart>
        </ResponsiveContainer>
    </div>
  );
});

const CustomTooltipChartTemperature = ({ active, payload, label, viewMode }) => {
  const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';
  const bgColor = isDarkMode ? '#2d2d2d' : '#ffffff';
  const textColor = isDarkMode ? '#ffffff' : '#1a1a1a';
  const borderColor = isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)';
  const secondaryTextColor = isDarkMode ? '#d1d5db' : '#6b7280';
  const tertiaryTextColor = isDarkMode ? '#9ca3af' : '#9ca3af';
  
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const isDaily = viewMode === 'daily';
    
    return (
      <div style={{ 
        backgroundColor: bgColor, 
        padding: '16px 20px', 
        border: `1px solid ${borderColor}`, 
        borderRadius: '12px',
        minWidth: '200px',
        maxWidth: '300px',
        boxShadow: isDarkMode 
          ? '0 8px 24px rgba(0, 0, 0, 0.4), 0 2px 6px rgba(0, 0, 0, 0.3)'
          : '0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.08)',
        zIndex: 1000,
        backdropFilter: 'blur(10px)'
      }}>
        <div style={{ 
          fontWeight: '600', 
          marginBottom: '12px', 
          fontSize: '14px', 
          color: textColor,
          paddingBottom: '10px',
          borderBottom: `1px solid ${borderColor}`
        }}>
          {data.time || data.date}
        </div>
        <div style={{ 
          marginBottom: isDaily ? '8px' : '0', 
          fontSize: '14px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span style={{ color: secondaryTextColor }}>Durchschnitt:</span>
          <span style={{ fontSize: '15px', fontWeight: '600', color: '#6366f1' }}>{data.data} °C</span>
        </div>
        {isDaily && data.min !== undefined && data.max !== undefined && (
          <>
            <div style={{ 
              marginBottom: '8px', 
              fontSize: '14px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <span style={{ color: secondaryTextColor }}>Minimum:</span>
              <span style={{ fontSize: '15px', fontWeight: '600', color: '#10b981' }}>{data.min} °C</span>
            </div>
            <div style={{ 
              marginBottom: '8px', 
              fontSize: '14px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <span style={{ color: secondaryTextColor }}>Maximum:</span>
              <span style={{ fontSize: '15px', fontWeight: '600', color: '#f59e0b' }}>{data.max} °C</span>
            </div>
            {data.count && (
              <div style={{ 
                fontSize: '12px', 
                color: tertiaryTextColor, 
                marginTop: '12px', 
                paddingTop: '12px', 
                borderTop: `1px solid ${borderColor}`,
                textAlign: 'center',
                fontWeight: 500
              }}>
                {data.count} Messungen
              </div>
            )}
          </>
        )}
      </div>
    );
  }

  return null;
};

const CustomTooltipChartHumidity = ({ active, payload, label, viewMode }) => {
  const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';
  const bgColor = isDarkMode ? '#2d2d2d' : '#ffffff';
  const textColor = isDarkMode ? '#ffffff' : '#1a1a1a';
  const borderColor = isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)';
  const secondaryTextColor = isDarkMode ? '#d1d5db' : '#6b7280';
  const tertiaryTextColor = isDarkMode ? '#9ca3af' : '#9ca3af';
  
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const isDaily = viewMode === 'daily';
    
    return (
      <div style={{ 
        backgroundColor: bgColor, 
        padding: '16px 20px', 
        border: `1px solid ${borderColor}`, 
        borderRadius: '12px',
        minWidth: '200px',
        maxWidth: '300px',
        boxShadow: isDarkMode 
          ? '0 8px 24px rgba(0, 0, 0, 0.4), 0 2px 6px rgba(0, 0, 0, 0.3)'
          : '0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.08)',
        zIndex: 1000,
        backdropFilter: 'blur(10px)'
      }}>
        <div style={{ 
          fontWeight: '600', 
          marginBottom: '12px', 
          fontSize: '14px', 
          color: textColor,
          paddingBottom: '10px',
          borderBottom: `1px solid ${borderColor}`
        }}>
          {data.time || data.date}
        </div>
        <div style={{ 
          marginBottom: isDaily ? '8px' : '0', 
          fontSize: '14px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span style={{ color: secondaryTextColor }}>Durchschnitt:</span>
          <span style={{ fontSize: '15px', fontWeight: '600', color: '#6366f1' }}>{data.data} %</span>
        </div>
        {isDaily && data.min !== undefined && data.max !== undefined && (
          <>
            <div style={{ 
              marginBottom: '8px', 
              fontSize: '14px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <span style={{ color: secondaryTextColor }}>Minimum:</span>
              <span style={{ fontSize: '15px', fontWeight: '600', color: '#10b981' }}>{data.min} %</span>
            </div>
            <div style={{ 
              marginBottom: '8px', 
              fontSize: '14px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <span style={{ color: secondaryTextColor }}>Maximum:</span>
              <span style={{ fontSize: '15px', fontWeight: '600', color: '#f59e0b' }}>{data.max} %</span>
            </div>
            {data.count && (
              <div style={{ 
                fontSize: '12px', 
                color: tertiaryTextColor, 
                marginTop: '12px', 
                paddingTop: '12px', 
                borderTop: `1px solid ${borderColor}`,
                textAlign: 'center',
                fontWeight: 500
              }}>
                {data.count} Messungen
              </div>
            )}
          </>
        )}
      </div>
    );
  }

  return null;
};


class DisplayCardLocation extends Component {
  render() {
    const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';
    
    // Dark Mode Tile Provider (Stadia Maps Alidade Smooth Dark)
    const darkTileProvider = (x, y, z, dpr) => {
      return `https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/${z}/${x}/${y}${dpr >= 2 ? '@2x' : ''}.png`;
    };
    
    // Light Mode Tile Provider (Standard OpenStreetMap)
    const lightTileProvider = (x, y, z, dpr) => {
      return `https://tile.openstreetmap.org/${z}/${x}/${y}.png`;
    };

    if(this.props.panel && this.props.panel.lat)
    {
      return (
        <div className="map-display">
            <Map 
              style={{height:'100%'}}  
              metaWheelZoom={true} 
              metaWheelZoomWarning="Verwenden Sie META+Maus-Rad" 
              defaultCenter={[parseFloat(this.props.panel.lat), parseFloat(this.props.panel.long)]} 
              defaultZoom={15}
              provider={isDarkMode ? darkTileProvider : lightTileProvider}
              dprs={[1, 2]}
            >
              <Marker width={30} anchor={[parseFloat(this.props.panel.lat), parseFloat(this.props.panel.long)]}>
               <div className="device-map-marker online">
                 <span className="device-map-marker-name">{this.props.panel.name || 'Koffer'}</span>
               </div>
              </Marker>
            </Map>
        </div>
      );
    }
    else {
      return (
        <div className="ko-empty">
          <div>Kein Standort hinterlegt</div>
        </div>
      );
    }
  }
}


DeviceOpen.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  history: PropTypes.object.isRequired
};

export default DeviceOpen;
